export default {
    "generalErrorMessage": {
        "fieldIsRequired": "Il campo è obbligatorio",
        "field_required": "Questo campo è obbligatorio",
        "something_went_wrong": "Qualcosa è andato storto"
    },
    "authErrorMessage": {
        "emailError": "Il campo email deve essere una email valida",
        "passwordValid": "Il campo password deve contenere almeno 8 caratteri",
        "validPassRegex": "Le password devono essere lunghe almeno 8 caratteri e contenere almeno 1 lettera, 1 maiuscola, 1 numero e 1 carattere speciale",
        "confirmPasswordValid": "La conferma della password non corrisponde",
        "validCharactersfirst": "Il campo nome può contenere solo caratteri alfabetici e spazi",
        "validCharacterslast": "Il campo cognome può contenere solo caratteri alfabetici e spazi",
        "minMust": "deve contenere almeno 3 caratteri",
        "must_be_a_valid_email": "Deve essere una email valida",
        "currentPassword": "le password attuali devono essere lunghe almeno 8 caratteri e contenere almeno 1 carattere alfabetico, 1 maiuscolo, 1 numerico e 1 carattere speciale",
        "newPassword": "le nuove password devono essere lunghe almeno 8 caratteri e contenere almeno 1 carattere alfabetico, 1 maiuscolo, 1 numerico e 1 carattere speciale",
        "currentPasswordValid": "Il campo della password corrente deve contenere almeno 8 caratteri",
        "newPasswordValid": "Il campo della nuova password deve contenere almeno 8 caratteri",
        "please_wait_before_resending_email": "Controlla la tua email. Se non l'hai ricevuta, puoi inviare nuovamente l'email di verifica dopo 1 minuto."
    },
    "companyErrorMessage": {
        "phoneNumberValid": "Il campo numero di telefono deve contenere almeno 10 caratteri",
        "Something_went_wrong_Please_contact_to_admin": "Qualcosa è andato storto. Contatta l'amministratore"
    },
    "errorPage": {
        "project_name": "Nome del progetto",
        "project_key": "Chiave del progetto",
        "project_category": "Categoria del progetto",
        "team_name": "Nome del team",
        "The": "Il",
        "field_must_be_a_valid": "Il campo deve essere valido",
        "email": "email",
        "password": "Password",
        "first_name": "Nome",
        "last_name": "Cognome",
        "company_name": "Nome della compagnia",
        "file_extension": "Estensione del file",
        "milestone_status": "Stato del traguardo",
        "name": "Nome",
        "phone_number": "Numero di telefono",
        "field_must_be_at_least": "Il campo deve contenere almeno",
        "number": "numero",
        "characters": "caratteri",
        "digits": "cifre",
        "priority_name": "Nome della priorità",
        "firstName": "Nome",
        "lastName": "Cognome",
        "phoneNumber": "Numero di telefono",
        "amount": "Importo",
        "phone": "Telefono",
        "country": "Paese",
        "state": "Stato",
        "city": "Città",
        "templatename": "Nome del template",
        "description": "Descrizione",
        "Template_name_is_required": "Il nome del template è obbligatorio",
        "This_template_name_is_required.": "Il nome del template è obbligatorio.",
        "status": "Stato",
        "zipcode": "CAP",
        "address2": "Indirizzo 2",
        "address1": "Indirizzo 1",
        "The_confirm_password_field_is_required": "Il campo conferma password è obbligatorio",
        "The_confirm_password_confirmation_does_not_match": "La conferma della password non corrisponde",
        "terms_and_condition": "Termini e condizioni",
        "category_name": "Nome categoria",
        "channel_name": "Nome canale",
        "amount_per_hours": "Importo per ora",
        "refundamount": "Importo del rimborso",
        "please_select_template": "Seleziona un template",
        "template_name_already_exists": "Il nome del template esiste già",
        "select_a_date": "Seleziona una data",
        "must_be_less_than": "deve essere inferiore a",
        "project_duedate": "Data di scadenza del progetto",
        "project_lead_assignee": "Responsabile del progetto",
        "current_password": "Password attuale",
        "new_password": "Nuova password",
        "confirm_password": "Conferma password",
        "This_template_name_is_already_exists": "Questo nome del template esiste già.",
        "card_name": "Nome della Carta",
        "topic": "argomento",
        "target_audience": "pubblico target",
        "keywords": "parole chiave",
        "content_purpose": "scopo del contenuto",
        "product/service": "prodotto/servizio",
        "campaign_goals": "obiettivi della campagna",
        "value_proposition": "proposta di valore",
        "objectives": "obiettivi",
        "key_message": "messaggio chiave",
        "problem": "problema",
        "context": "contesto",
        "constraints": "vincoli",
        "main_keyword": "parola chiave principale",
        "secondary_keywords": "parole chiave secondarie",
        "content_goal": "obiettivo del contenuto",
        "keyword_list": "elenco parole chiave",
        "questions": "domande",
        "product_description": "descrizione del prodotto",
        "feedback_data": "dati di feedback",
        "survey_questions": "domande del sondaggio",
        "project": "progetto",
        "progress_made": "progressi realizzati",
        "next_steps": "prossimi passi",
        "key_features": "caratteristiche principali",
        "client_type": "tipo di cliente",
        "challenges": "sfide",
        "results": "risultati",
        "event_type": "tipo di evento",
        "cta": "invito all'azione",
        "campaign_objectives": "obiettivi della campagna",
        "survey_objectives": "obiettivi del sondaggio",
        "column_one_name": "nome prima colonna",
        "column_two_name": "nome seconda colonna",
        "column_one_data": "dati prima colonna",
        "column_two_data": "dati seconda colonna",
        "customer_name": "nome cliente",
        "email_purpose": "scopo dell'email",
        "talking_points": "punti di discussione",
        "product_name": "nome del prodotto",
        "about_the_product": "informazioni sul prodotto",
        "core_problem_it_solves": "problema principale che risolve",
        "what_makes_it_different": "cosa lo rende diverso",
        "the_product_is": "il prodotto è",
        "core_differentiators": "differenziatori principali",
        "product/service_benefits": "benefici del prodotto/servizio",
        "call_notes": "note della chiamata",
        "call_transcript": "trascrizione della chiamata",
        "target_company": "azienda target",
        "use_case": "caso d'uso",
        "customer_challenges": "sfide del cliente",
        "territories": "territori",
        "target_industries": "settori target",
        "sales_goals": "obiettivi di vendita",
        "sales_strategies": "strategie di vendita",
        "transcript": "trascrizione",
        "pain_points": "punti critici",
        "company_type": "tipo di azienda",
        "sales_cycle_stages": "fasi del ciclo di vendita",
        "sales_methodologies": "metodologie di vendita",
        "key_skills": "competenze chiave",
        "training_formats": "formati di formazione",
        "participants": "partecipanti",
        "target_industry": "settore target",
        "value_statement": "dichiarazione di valore",
        "meeting_type": "tipo di riunione",
        "your_talking_points": "i tuoi punti di discussione",
        "goal": "obiettivo",
        "reasons_for_canceling": "motivi di cancellazione",
        "incentive": "incentivo",
        "unique_selling_points": "punti di vendita unici",
        "desired_format": "formato desiderato",
        "topics": "argomenti",
        "content": "contenuto",
        "stakeholders": "stakeholder",
        "sales_notes": "note di vendita",
        "customer_goals": "obiettivi del cliente",
        "teams_impacted": "team coinvolti",
        "requirements": "requisiti",
        "goals_met": "obiettivi raggiunti",
        "project_stakeholders": "stakeholder del progetto",
        "opportunities": "opportunità",
        "risks": "rischi",
        "customer_message": "messaggio del cliente",
        "date_range": "intervallo di date",
        "project_notes": "note del progetto",
        "project_description": "descrizione del progetto",
        "name_of_project": "nome del progetto",
        "date_ranges": "intervalli di date",
        "requestor": "richiedente",
        "requests": "richieste",
        "reason_for_the_change": "motivo del cambiamento",
        "expected_impact_of_the_change": "impatto previsto del cambiamento",
        "project_goals": "obiettivi del progetto",
        "participant_names": "nomi dei partecipanti",
        "meeting_time": "orario della riunione",
        "timeline": "tempistica",
        "deliverables": "consegnabili",
        "project_goal": "obiettivo del progetto",
        "project_scope": "ambito del progetto",
        "main_task": "compito principale",
        "new_format": "nuovo formato",
        "original_text": "testo originale",
        "stakeholder_titles": "titoli degli stakeholder",
        "article_title": "titolo dell'articolo",
        "focus_keywords": "parole chiave focus",
        "title_of_the_blog_text": "titolo del testo del blog",
        "blog_topic": "argomento del blog",
        "section_title": "titolo della sezione",
        "section_content": "contenuto della sezione",
        "section": "sezione",
        "title": "titolo",
        "title(faq_question)": "titolo(domanda FAQ)",
        "issue_description": "descrizione del problema",
        "code_section": "sezione di codice",
        "concept": "concetto",
        "version": "versione",
        "changes": "cambiamenti",
        "job_title": "titolo di lavoro",
        "your_name": "il tuo nome",
        "your_skills": "le tue competenze",
        "math_question": "domanda di matematica",
        "question": "domanda",
        "thesis_topic": "argomento della tesi",
        "text_to_proofread": "testo da correggere",
        "text_to_rephrase": "testo da riformulare",
        "text_to_improve": "testo da migliorare",
        "job_description": "descrizione del lavoro",
        "your_title": "il tuo titolo",
        "your_summary": "il tuo riassunto",
        "pain": "dolore",
        "agitation": "agitazione",
        "solution": "soluzione",
        "post_content": "contenuto del post",
        "product_or_service": "prodotto o servizio",
        "unique_selling_proposition": "proposta di vendita unica",
        "email_to_reply_to": "campo email di risposta",
        "audiences_objectives": "obiettivi del pubblico",
        "sales_teams_roles": "ruoli del team vendite"
    },
    "Auth": {
        "email": "Email",
        "password": "Password",
        "firstName": "Nome",
        "lastName": "Cognome",
        "phoneNumber": "Numero di telefono",
        "login_descriptioon": "Vedi cosa sta succedendo con la tua attività",
        "login_statement": "Accedi al tuo account",
        "email_id": "ID Email",
        "Password": "Password",
        "Conform_pass": "Conferma Password",
        "RememberMeL": "Ricordami",
        "Remember_password": "Ricorda la password",
        "Forgot_Password": "Password dimenticata",
        "loading": "Caricamento",
        "loging": "Accedi",
        "Register": "Registrati",
        "NotR": "Non registrato ancora",
        "createAcc": "Crea un account",
        "alredyacc": "Hai già un account?",
        "ResendEmail": "Rinvia email",
        "pleasecheck": "Per favore controlla la tua email. Se non l'hai ricevuta o l'hai smarrita, clicca sotto per rinviare l'email.",
        "backlogin": "Torna al login",
        "Welcome_Msg": "Benvenuto su BRAND_NAME",
        "Welcome_Description": "Ottieni accesso a funzionalità esclusive creando un account",
        "agree": "Accetto i",
        "tearm": "Termini di servizio",
        "and": "e",
        "Privacy_Policy": "Politica sulla privacy",
        "forgatepasswordmsg": "Inserisci l'email associata al tuo account e ti invieremo un'email con le istruzioni per reimpostare la tua password.",
        "ltitle": "Lavora su grandi idee, senza il lavoro noioso.",
        "time_format": "Formato ora",
        "timezone": "Fuso orario",
        "selectLanguage": "Seleziona lingua",
        "check_credentials": "Per favore controlla le tue credenziali.",
        "check_smtp_credentials": "Per favore controlla le tue credenziali SMTP.",
        "smtp_successfully_verified": "Il tuo SMTP è stato verificato con successo.",
        "verification_code_invalid": "Il tuo codice di verifica non è valido.",
        "verification_code_invalid_check_code": "Il tuo codice di verifica non è valido. Per favore verifica il tuo codice.",
        "verification_mail_sent": "L'email di verifica è stata inviata con successo. Controlla la tua casella di posta.",
        "no_account_found_for_email": "Nessun account trovato per l'email fornita.",
        "verify_email_and_try_again": "Verifica la tua email e riprova.",
        "confirm_password": "Conferma password",
        "enter_new_password": "Inserisci la tua nuova password",
        "link_expired_resend_email": "Il tuo link è scaduto.",
        "reset_password": "Reimposta password",
        "resend_verification_email": "Per favore clicca sul pulsante per rinviare l'email di verifica.",
        "link_expired": "Questo link è scaduto",
        "too_many_request": "Hai inviato troppe richieste in un determinato periodo di tempo. Attendi e riprova più tardi.",
        "previous_wasnot_valid": "La tua password precedente non era valida. Verifica e riprova.",
        "password_wasnot_valid": "La tua nuova password non era valida. Riprova.",
        "set_new_password": "Imposta nuova password",
        "verification_link_expired": "Questo link di verifica è scaduto.",
        "verification_link_expired_message": "Si prega di controllare la propria casella di posta per l'ultima email di verifica. Se non l'hai ricevuta, prova ad accedere nuovamente per richiederne una nuova.",
        "oAuthGoogleBtnText": "Continua con Google"
    },
    "Home": {
        "unlock": "Sblocca",
        "lock": "Blocca",
        "dashboardLockSuccess": "Dashboard bloccata con successo",
        "dashboardUnlockSuccess": "Dashboard sbloccata con successo",
        "Home": "Home",
        "My_Work": "Il mio lavoro",
        "Done": "Fatto",
        "To_Do": "Da fare",
        "no_task_found": "Nessuna attività trovata",
        "Confirm": "Conferma",
        "tourclose": "Sei sicuro di voler chiudere questo tour? Se confermi, non sarai in grado di accedere di nuovo a questa guida.",
        "Queue_List": "Lista in coda",
        "AddtoQueue": "Aggiungi alla coda",
        "noquelist": "Nessuna lista in coda trovata",
        "Due_Date": "Data di scadenza",
        "createQueueTitle": "Crea coda",
        "Today": "Oggi",
        "Calendar": "Calendario",
        "Hide": "Nascondi",
        "Overdue": "In ritardo",
        "Next": "Prossimo",
        "Unscheduled": "Non programmato",
        "task_assign_to_you": "compito assegnato a te",
        "Notification_Request": "Richiesta di notifica",
        "no": "No",
        "yes": "Sì",
        "add_task_type": "Aggiungi tipo di attività",
        "are_you_sure": "Vuoi abilitare le notifiche del browser?"
    },
    "Header": {
        "Project_Forecasting": "Previsione del progetto (In arrivo)",
        "Resource_Planning": "Pianificazione delle risorse (In arrivo)",
        "Projects": "Progetti",
        "Time_Sheet": "Foglio ore",
        "User_Timesheet": "Foglio ore utente",
        "project_Timesheet": "Foglio ore progetto",
        "Workload_Timesheet": "Foglio ore carico di lavoro",
        "Tracker_Timesheet": "Foglio ore tracker",
        "Reports": "Report",
        "Milestone_Report": "Report dei traguardi",
        "Time_Forcasting": "Previsione del tempo",
        "Chat": "Chat",
        "Notification": "Notifica",
        "mention": "Menzione",
        "Tours": "Tour",
        "Logout": "Esci",
        "Mark_all_as_read": "Segna tutto come letto",
        "Mark_all_as_complete": "Segna tutto come completato",
        "designation": "Designazione",
        "upgrade_now": "Aggiorna ora",
        "load_more": "Carica di più",
        "take_tour": "Fai un tour",
        "task_details": "Dettagli attività",
        "Comments": "Commenti",
        "activity_log": "Registro attività",
        "time_log": "Registro ore",
        "mentions": "Menzioni",
        "Notifications": "Notifiche",
        "no_data_found": "Nessun dato trovato",
        "search_results": "Risultati della ricerca",
        "my_profile": "Il mio profilo",
        "billing_history": "Storia fatturazione",
        "Assignee": "Assegnatario",
        "Due Date": "Data di scadenza",
        "Priority": "Priorità",
        "Key": "Chiave",
        "Created Date": "Data di creazione",
        "Created By": "Creato da",
        "advance_search": "Ricerca avanzata",
        "for_advance_search": "Per ricerca avanzata",
        "get_more": "Vuoi più?",
        "to_unlock_activity_view": "Per sbloccare la vista attività",
        "AssigneeUserId": "Assegnatario",
        "DueDate": "Data di scadenza",
        "TaskKey": "Chiave attività",
        "Task_Priority": "Priorità attività",
        "commentCounts": "Chat",
        "created_by": "Creato da",
        "created_date": "Data di creazione",
        "create_project": "Crea progetto",
        "Company": "Azienda"
    },
    "ProjectDetails": {
        "select_project_category": "Seleziona Categoria del Progetto",
        "select_currency": "Seleziona Valuta",
        "description": "Descrizione",
        "details": "Dettagli",
        "status": "Stato",
        "assignee": "Assegnatario",
        "key": "Chiave",
        "category": "Categoria",
        "source": "Fonte",
        "type": "Tipo",
        "billing_period": "Periodo di Fatturazione",
        "currency": "Valuta",
        "amount": "Importo",
        "start_date": "Data di Inizio",
        "end_date": "Data di Fine",
        "no_start_date": "Nessuna Data di Inizio",
        "no_end_date": "Nessuna Data di Fine",
        "no_due_date": "Nessuna Data di Scadenza",
        "msg": "La data di inizio non può essere modificata perché è già",
        "msgbr": "all'interno di un intervallo di traguardi.",
        "startdatemsg0": "La data di inizio non può essere modificata perché è già",
        "startdatemsg1": "all'interno di un intervallo di traguardi.",
        "ok": "ok",
        "lead": "Lead",
        "browse_by_category": "Esplora per categoria",
        "subtask": "Sottoattività",
        "details_project_setup": "Dettagli della configurazione del progetto",
        "avatar": "Avatar",
        "shared_with": "Condiviso con",
        "no_user_selected": "Nessun Utente Selezionato",
        "required_view": "Visualizzazioni richieste",
        "set_the_require": "Imposta la vista(i) richieste. Queste viste verranno automaticamente utilizzate quando navigherai su Progetti, Cartelle e Liste in BRAND_NAME invece di crearle manualmente. Una volta create, le viste non possono essere eliminate.",
        "always_required": "Sempre Richiesto",
        "make_default": "Imposta come predefinito",
        "reporter": "Reporter",
        "copy_task_link": "Copia Link Attività",
        "copy_task_key": "Copia Chiave Attività",
        "add_que_list": "Aggiungi alla Lista in Coda",
        "remove_que_list": "Rimuovi dalla Lista in Coda",
        "convert_list": "Converti in Lista",
        "convert_subtask": "Converti in Sottoattività",
        "merge": "Unisci",
        "move": "Sposta",
        "convert_task": "Converti in Attività",
        "no_currency_found": "Nessuna valuta trovata",
        "remove_from_queue_list": "Rimuovi dalla Lista in Coda",
        "convert": "Converti",
        "DUPLICATE_AND_OPEN": "Duplica e Apri",
        "MOVE_AND_OPEN": "Sposta e Apri",
        "CONVERT_AND_OPEN": "Converti e Apri",
        "MERGE_AND_OPEN": "Unisci e Apri"
    },
    "ProjectSlider": {
        "new_project": "Nuovo Progetto",
        "no_archived": "Nessun Dato Archiviato Trovato",
        "you_dont": "Non hai nessun progetto",
        "archived_list": "Lista Archiviata",
        "projects": "Progetti",
        "project_name": "Nome del Progetto",
        "folder_name": "Nome della Cartella",
        "sprint_name": "Nome Sprint",
        "show_archive": "Mostra Archivio",
        "hide_archive": "Nascondi Archivio",
        "try_using_diff": "Prova a usare parole chiave diverse",
        "no_project_found": "Nessun progetto trovato",
        "no_result_found": "Nessun Risultato trovato",
        "select_project_status": "Seleziona Stato del Progetto",
        "no_activity_log_found": "Nessun registro attività trovato"
    },
    "Projects": {
        "sprint": "Sprint",
        "folder": "Cartella",
        "task_view": "Vista Attività",
        "default_view": "Vista Predefinita",
        "add_view": "Aggiungi Vista",
        "rename": "Rinomina",
        "pin": "Fissa",
        "edit_code": "Modifica Codice",
        "copy_link": "Copia Link",
        "delete": "Elimina",
        "view": "Vista",
        "watchers": "Osservatori",
        "files_links": "File & Link",
        "audio_files": "File Audio",
        "project_permissions": "Permessi del Progetto",
        "color_avatar": "Colore & Avatar",
        "duplicate": "Duplica",
        "close_project": "Chiudi Progetto",
        "archive": "Archivia",
        "search_in": "Cerca In",
        "expanded": "Espanso",
        "collapsed": "Compresso",
        "me": "Io",
        "status": "Stato",
        "priority": "Priorità",
        "due_date": "Data di Scadenza",
        "group_by": "Raggruppa per",
        "subtask": "Sottoattività",
        "task_name": "Nome Attività",
        "task_key": "Chiave Attività",
        "everyone": "Tutti",
        "private": "Privato",
        "share_with": "Condividi Con",
        "create_new_list": "Crea Nuovo Sprint",
        "create_new_folder": "Crea Nuova Cartella",
        "restore": "Ripristina",
        "unpin": "Slega Vista",
        "pinview": "Fissa Vista",
        "deleteview": "Elimina Vista",
        "close": "Chiudi",
        "cancel": "Annulla",
        "tasks": "Attività",
        "save": "Salva",
        "create_project": "Crea Progetto",
        "use_template": "Usa Template",
        "blank_project": "Progetto Vuoto",
        "no_category_found": "Nessuna categoria trovata",
        "template": "Template",
        "save_create": "Salva & Crea",
        "save_tamplete": "Salva come Template",
        "previous": "Precedente",
        "new_task": "Nuova Attività",
        "add_subtask": "Aggiungi Sottoattività",
        "list_of_user": "Lista degli Utenti",
        "list_of_project_status": "Lista degli Stati del Progetto",
        "list_of_task_type": "Lista dei Tipi di Attività",
        "list_of_task_status": "Lista degli Stati delle Attività",
        "list_cc": "Lista cc",
        "category_list": "Lista Categorie",
        "created_by": "Creato da",
        "tags": "Tag",
        "task_type": "Tipo di Attività",
        "workspace": "Spazio di lavoro",
        "project_color": "Colore del Progetto",
        "search": "Cerca",
        "add_task_need": "Aggiungi il tipo di attività di cui hai bisogno",
        "what_task_want": "Che tipo di attività desideri",
        "no_sub_tasks_found": "Nessuna sottoattività trovata",
        "all_project": "Tutti i Progetti",
        "closed_project": "Progetto Chiuso",
        "go_to_project": "Vai ai Progetti",
        "reopen_project": "Riapri Progetto",
        "required_view": "Vista Richiesta",
        "project_status": "Aggiungi gli stati per il progetto",
        "what_project": "Che stato di progetto desideri",
        "active_status": "Stato Attivo",
        "done_status": "Stato Completato",
        "add_status": "Aggiungi Stato",
        "close_status": "Chiudi Stato",
        "submit": "Invia",
        "Audio_Files": "File Audio",
        "Files_&_Links": "File & Link",
        "no_audio_file": "Nessun file audio trovato",
        "change_color": "Cambia colore & avatar",
        "files": "File",
        "links": "Link",
        "about": "Informazioni",
        "result": "risultati",
        "seconds": "secondi",
        "sort_by": "Ordina per",
        "relevance": "Rilevanza",
        "last_update": "Ultimo Aggiornamento",
        "last_created": "Ultima Creazione",
        "issue": "Problema",
        "update": "Aggiorna",
        "date": "Data",
        "time": "Ora",
        "duration": "Durata",
        "duplicate_task": "Attività Duplicata",
        "projects": "Progetti",
        "browse_projects": "Esplora Progetti",
        "location": "Posizione",
        "add_new": "Aggiungi Nuovo",
        "create_compnay": "Crea Azienda",
        "company_name": "Nome Azienda",
        "archived_project": "Progetto Archiviato",
        "assignee_teams": "Squadre",
        "assignee_user": "Utenti",
        "all": "Tutti",
        "restore_project": "Ripristina Progetto",
        "delete_project": "Elimina Progetto",
        "items_per_page": "Elementi per pagina",
        "Assignee": "Assegnatario",
        "Project_Created_Date": "Data Creazione Progetto",
        "Project_Status": "Stato del Progetto",
        "Project_Type": "Tipo di Progetto",
        "Comments_Counts": "Conteggio Commenti",
        "Created_Date": "Data di Creazione",
        "Name": "Nome",
        "Running_Time_Tracker": "Tracker Tempo in Esecuzione",
        "Assigned_to": "Assegnato a",
        "Project": "Progetto",
        "Currency": "Valuta",
        "Milestone_Type": "Tipo di Traguardo",
        "Project_Category": "Categoria del Progetto",
        "Comment_Type": "Tipo di Commento",
        "results_in_time": "Risultati in",
        "create_blank_project": "Crea Progetto Vuoto",
        "create_project_using_template": "Crea Progetto Usando Template",
        "choose_apps": "Scegli app"
    },
    "Watcher": {
        "ignore": "Ignora",
        "participating_mentions": "Partecipazione e menzioni {'@'}",
        "list_of_watcher": "Lista di Osservatori",
        "all_activity": "Tutta l'attività",
        "watchers_list": "Lista degli osservatori",
        "owner": "Proprietario"
    },
    "ViewList": {
        "List": "Lista",
        "Board": "Board",
        "Project Details": "Dettagli del Progetto",
        "Comments": "Commenti",
        "Calendar": "Calendario",
        "Activity": "Attività",
        "Workload": "Carico di lavoro",
        "Gantt": "Gantt",
        "Table": "Tabella",
        "Timeline": "Timeline",
        "Embed": "Incorpora",
        "Comment": "Commento",
        "to_unlock_list_view": "Per sbloccare la vista della lista",
        "error_message_for_empty": "Seleziona almeno una vista",
        "set_as_default": "Imposta come predefinito",
        "remove_as_default": "Rimuovi como predefinito"
    },
    "Apps": {
        "tags": "Tag",
        "Priority": "Priorità",
        "TimeEstimates": "Stima del Tempo",
        "Milestones": "Traguardi",
        "MultipleAssignees": "Assegnatari Multipli",
        "CustomFields": "Campi Personalizzati",
        "TimeTracking": "Tracciamento del Tempo",
        "AI": "AI"
    },
    "Tags": {
        "no_tags_found": "Nessun Tag Trovato",
        "search_or_create_new": "Cerca o Crea Nuovo",
        "change_color": "Cambia Colore",
        "delete_tag": "Elimina Tag",
        "delete_tag_desc": "Sei sicuro di voler eliminare il tag ovunque in questo spazio?",
        "note_msg": "Premi Invio per creare un nuovo tag",
        "This_tag_has_already_been_added": "Questo tag è già stato aggiunto",
        "Tag_name_required": "Nome del tag richiesto"
    },
    "Embeded": {
        "Anything": "Qualsiasi cosa",
        "Sheets": "Google Sheets",
        "Docs": "Google Docs",
        "Youtube": "Youtube",
        "Figma": "Figma",
        "The_name_is_required": "Il nome è richiesto",
        "The_name_should_be_at_least_3_characters_long": "Il nome dovrebbe essere lungo almeno 3 caratteri",
        "The_url_is_required": "L'URL è richiesto",
        "Please_enter_valid_url": "Per favore inserisci un URL valido",
        "URL_already_exists": "L'URL esiste già",
        "The_Html_code_is_required": "Il codice Html è richiesto",
        "name_already_exists": "Questo nome esiste già",
        "to_unlock_embed_view": "Per sbloccare la vista incorporata"
    },
    "ViewListdescription": {
        "list_view": "Usa la vista Lista per organizzare le tue attività in qualsiasi modo immaginabile: ordina, filtra, raggruppa e personalizza le colonne.",
        "kanban_view": "Costruisci la tua Board perfetta e sposta facilmente le attività tra le colonne.",
        "projectdetail_view": "Aggiungi requisiti iniziali, checklist e allegati affinché il tuo team comprenda i dettagli.",
        "Comments_view": "Aggiungi commenti in tempo reale su qualsiasi cosa con il tuo team, così verranno notificati e potranno rispondere.",
        "calender_view": "La vista Calendario è il tuo posto per pianificare, programmare e gestire le risorse.",
        "table_view": "Gestisci facilmente, aggiorna e organizza le tue attività con la vista Tabella.",
        "workload_view": "Visualizza la capacità del tuo team, chi è sovraccarico o sotto e riassegna le attività di conseguenza.",
        "activitylog_view": "Ottieni una vista aggregata di tutte le attività in una posizione. Filtra per persone e tipo per ottenere dettagli sulle attività.",
        "add_msg1": "Aggiungi app e siti web accanto alle tue attività con la vista Incorpora",
        "add_msg2": "per risparmiare tempo e ridurre il cambio di contesto.",
        "view_name": "Nome della Vista",
        "embed_URL": "URL Incorpora",
        "embed_HTML": "HTML da incorporare",
        "private_view": "Vista Privata"
    },
    "Filters": {
        "filter": "Filtri",
        "learnmorefilter": "Scopri di più sui filtri",
        "pleaseselectvalid": "Seleziona tutte le opzioni valide",
        "confirm": "Conferma",
        "are_you_sure": "Sei sicuro di voler eliminare",
        "clearall": "Cancella tutto",
        "addfilter": "Aggiungi filtro",
        "where": "Dove",
        "filtering_field": "Campo di filtro",
        "no_date_found": "Nessuna data trovata",
        "save_this_filters": "Salva questi filtri",
        "save_filter": "Salva filtro",
        "save": "Salva",
        "update_filter": "Aggiorna filtro",
        "my_filter": "Il mio filtro",
        "no_data_found": "Nessun dato trovato",
        "show_result": "Mostra risultato",
        "save_filters": "Salva filtri",
        "filter_by": "Filtra per",
        "projects": "Progetti",
        "teams": "Team",
        "user": "Utente",
        "no_comment_found": "Nessun commento trovato",
        "no_project_found": "Nessun progetto trovato",
        "no_file_found": "Nessun file trovato",
        "no_link_found": "Nessun link trovato",
        "filter_operator": "Operatore di filtro",
        "options": "Opzioni",
        "priorities": "Priorità",
        "select_all": "Seleziona tutto",
        "milestone_type": "Tipo di traguardo",
        "comment_type": "Tipo di commento",
        "a_to_z": "A a Z",
        "no_files_found": "Nessun file trovato",
        "no_links_found": "Nessun link trovato",
        "no_links_or_files_found": "Nessun link o file trovato",
        "z_to_a": "Z a A",
        "sort_by": "Ordina per",
        "A-Z": "A-Z",
        "Ascending": "Crescente",
        "Descending": "Decrescente",
        "No": "No",
        "Yes": "Sì",
        "Z-A": "Z-A",
        "Save_this_Filter": "Salva questo filtro",
        "Enter_Filter_Name": "Inserisci il nome del filtro",
        "Select_Options": "Seleziona opzioni",
        "Equal_To": "Uguale a",
        "Greater_Than": "Maggiore di",
        "Is": "È",
        "Less_Than": "Minore di",
        "Clear_All": "Cancella tutto",
        "select_assignee": "Seleziona assegnatario",
        "select_project_types": "Seleziona tipi di progetto",
        "unselect_all": "Deseleziona tutto",
        "are_you_suredelete": "Sei sicuro di voler eliminare?",
        "Not_Equals_To": "Non è"
    },
    "conformationmsg": {
        "archive": "Una lista può essere archiviata per nasconderla dalla vista, ma può essere ripristinata in qualsiasi momento. Tutte le attività vengono conservate e rimangono ricercabili quando archivi una lista.",
        "delete": "Le attività e i modelli di questo progetto saranno cancellati. Digita il nome del progetto per confermare che desideri veramente eliminare tutte le attività, i modelli e questo progetto.",
        "archive0mesg": "Digita il nome del progetto per confermare che desideri veramente chiudere questo progetto",
        "sprintclosemsg": "Digita il nome dello sprint per confermare che desideri veramente chiudere questo sprint",
        "type": "Tipo",
        "are_you_sure": "Sei sicuro?",
        "no_revert_msg": "Non sarai in grado di annullarlo!",
        "yes_delete": "Sì, eliminalo!",
        "task_will_become_subtasks_of": "l'attività diventerà sottoattività di",
        "Are_you_sure_you_want_to_delete": "Sei sicuro di voler eliminare",
        "subtasks_will_become_subtasks_of": "Le sottoattività diventeranno sottoattività di",
        "unlock_board_view": "Per sbloccare la vista Board",
        "unlock_project_detail_view": "Per sbloccare la vista Dettagli del progetto",
        "unlock_table_view": "Per sbloccare la vista Tabella",
        "unlock_workload_view": "Per sbloccare la vista Carico di lavoro",
        "to_unlock_tracker_timesheet": "Per sbloccare la Timesheet Tracker",
        "to_unlock_user_timesheet": "Per sbloccare la Timesheet Utente",
        "unlock_calendar_view": "Per sbloccare la vista Calendario"
    },
    "Description": {
        "description": "Descrizione",
        "edit": "Modifica",
        "add_description": "Aggiungi una descrizione",
        "show_more": "Mostra di più",
        "show_less": "Mostra di meno",
        "description_placeholder": "Scrivi qualcosa o digita '/' per comandi e azioni AI",
        "saved": "Salvato"
    },
    "Checklist": {
        "checklist": "Lista di controllo",
        "add_checklist": "Aggiungi una Lista di controllo",
        "suggest_checklists": "Suggerisci Liste di controllo",
        "Checklists": "Liste di controllo",
        "to_unlock_checklist": "Per sbloccare la lista di controllo"
    },
    "Attachments": {
        "attachments": "Allegati",
        "drag_file": "Qui puoi anche trascinare e rilasciare file.",
        "see_all": "Vedi tutti",
        "drop_file": "Trascina i file qui per allegarli o",
        "browse": "Sfoglia",
        "no_preview_found": "Nessuna anteprima trovata",
        "show_all_pages": "Mostra tutte le pagine",
        "drop_here": "Trascina qui"
    },
    "Milestone": {
        "milestone": "Traguardo",
        "milestone_name": "Nome del traguardo",
        "status_date": "Data di stato",
        "total_amount": "Importo totale",
        "are_you_sure": "Sei sicuro di voler eliminare il traguardo?",
        "add_new": "Aggiungi un nuovo",
        "mileston_status": "Stato del traguardo",
        "project_name": "Nome del progetto",
        "end_date": "Data di fine",
        "start_date": "Data di inizio",
        "estimated_release": "Rilascio stimato",
        "release_request_sent": "Richiesta di rilascio inviata",
        "released": "Rilasciato",
        "not_funded": "Non finanziato",
        "funded": "Finanziato",
        "project_milestone_Status": "Stato del traguardo del progetto",
        "milestone_status_name": "Nome dello stato del traguardo",
        "date_displaye": "Data visualizzata nel calendario",
        "past": "Passato",
        "feature": "Futuro",
        "milestone_weekly_range": "Intervallo settimanale del traguardo",
        "file_extensions": "Estensioni di file",
        "avatar": "Avatar",
        "adding_estimated": "Aggiungi ore stimate",
        "range": "Intervallo",
        "user": "Utente",
        "refunded_amount": "Importo rimborsato",
        "Max_2_decimal_places_allowed": "Max 2 decimali consentiti",
        "The_refunded_amount_field_should_not_be_more_then_amount": "Il campo dell'importo rimborsato non deve essere maggiore dell'importo",
        "Amount_field_should_not_be_smaller_than_the_refunded_amount": "Il campo dell'importo non deve essere inferiore all'importo rimborsato",
        "The_minute_field_must_be_59_or_less": "Il campo dei minuti deve essere 59 o meno",
        "The_hours_field_is_required": "Il campo delle ore è obbligatorio",
        "Name_already_exists": "Il nome esiste già",
        "The_milestone_status_field_is_required": "Il campo dello stato del traguardo è obbligatorio",
        "The_milestone_status_field_must_be_at_leat_characters": "Il campo dello stato del traguardo deve contenere almeno 3 caratteri",
        "actual_amount": "Importo effettivo",
        "partially_refunded": "Parzialmente rimborsato",
        "refunded_amount_should_not_exceed_amount": "Il campo dell'importo rimborsato non deve superare l'importo",
        "total_partially_refunded": "Totale parzialmente rimborsato",
        "field_should_not_be_smaller_than_refund_amount": "Il campo non deve essere inferiore all'importo del rimborso",
        "white_color_not_allowed": "Il colore bianco non è consentito. Seleziona un colore valido",
        "billing": "Fatturazione",
        "per_hour": "Per ora",
        "adding_taskPlanning": "Aggiungi Pianificazione delle attività"
    },
    "Comment": {
        "created_by": "Creato da",
        "created_on": "Creato il",
        "task_name": "Nome attività"
    },
    "UserTimesheet": {
        "back_projects": "Torna ai Progetti",
        "user_timesheet": "Timesheet Utente",
        "back": "Indietro",
        "tracked_time": "Tempo Tracciato",
        "manual_time": "Tempo Manuale",
        "users": "Utenti",
        "logged": "Registrato",
        "hours": "Ore",
        "estimated": "Stimato",
        "no_records_found": "Nessun record trovato",
        "project_timesheet": "Timesheet Progetto",
        "tracker_timesheet": "Timesheet Tracker",
        "workload_timesheet": "Timesheet Carico di Lavoro",
        "milestone_reports": "Rapporti Milestone",
        "add_time": "Aggiungi Tempo",
        "add_time_log": "Aggiungi Registro Tempo",
        "edit_time_log": "Modifica Registro Tempo",
        "Teams": "Squadre",
        "Users": "Utenti",
        "Projects": "Progetti",
        "task_planning": "Pianificazione delle attività",
        "task_remaining_planning": "Ore rimanenti",
        "planned": "Pianificato"
    },
    "ProjectWorkplace": {
        "msg1": "Il progetto può essere condiviso con i membri. Puoi aggiungere ospiti a Cartelle, Liste e attività dopo aver creato un Progetto.",
        "msg2": "Attualmente non ci sono piani per creare progetti privati o pubblici. Se desideri avviare un progetto, sarà necessario aggiornare il piano."
    },
    "CustomField": {
        "custom_field": "Campo Personalizzato",
        "create_custom_field": "Crea Campo Personalizzato",
        "lable": "Etichetta",
        "action": "Azione",
        "add_custom_field": "Aggiungi Campo Personalizzato",
        "add_new_custom_field": "Aggiungi Nuovo Campo Personalizzato",
        "field_name": "Nome del Campo",
        "date_created": "Data di Creazione",
        "add_another_item": "Aggiungi un altro elemento",
        "choose_ready_made_list": "Scegli una lista predefinita di opzioni (ad esempio, giorni, mesi, ecc.)",
        "predefined_options": "Opzioni Predefinite",
        "selected_by_default": "Selezionato per impostazione predefinita",
        "allow_time_with_date": "Consenti agli utenti di specificare un'ora con la data.",
        "date_format": "Formato Data",
        "days_of_week": "Giorni della settimana",
        "past_and_future": "Passato e Futuro",
        "select_date_format": "Seleziona un formato di data. D sta per giorno, M per mese e Y per anno.",
        "select_dates_past_future": "Consenti agli utenti di selezionare date nel passato o nel futuro",
        "select_time_format": "Seleziona un formato orario",
        "time_format": "Formato Orario",
        "unchecking_day_calendar": "Deselezionare un giorno renderà il giorno non disponibile nel calendario",
        "future": "Futuro",
        "past": "Passato",
        "enter_maximum_limit": "Inserisci il limite massimo",
        "enter_minimum_limit": "Inserisci il limite minimo",
        "limit_minimum_or_maximum_value": "Limita il valore minimo o massimo consentito per questo campo",
        "maximum_limit_type_not_allowed_value": "Il valore inserito per il tipo di limite massimo non è un valore consentito.",
        "maximum_value_should_be_greater_than_minimum_value": "Il valore massimo deve essere maggiore del valore minimo",
        "minimum_limit_type_not_allowed_value": "Il valore inserito per il tipo di limite minimo non è un valore consentito.",
        "minimum_value_should_not_be_greater_than_maximum_value": "Il valore minimo non deve essere maggiore del valore massimo",
        "no_country_found": "Nessun paese trovato",
        "enter_maximum_limit_type": "Inserisci il tipo di limite massimo",
        "enter_minimum_limit_type": "Inserisci il tipo di limite minimo",
        "limit_minimum_or_maximum_text_allowed": "Limita la quantità minima o massima di testo consentita in questo campo",
        "max_should_be_greater_than_min": "Il massimo dovrebbe essere maggiore del minimo",
        "min_should_be_less_than_max": "Il minimo dovrebbe essere inferiore al massimo",
        "separator": "Separatore",
        "countryCode": "Attivalo per modificare il codice del paese."
    },
    "Category": {
        "cateory_name": "Nome della Categoria",
        "create_category": "Crea Categoria",
        "create_channel": "Crea Canale",
        "no_chat_found": "Nessuna chat trovata",
        "upgradeplanemsg": "Per accedere a questa funzione, aggiorna il tuo piano."
    },
    "Channel": {
        "create_channel": "Crea Canale",
        "msg1": "Hai raggiunto il limite massimo di creazione canali pubblici e privati. Per accedere a questa funzione, aggiorna il tuo piano",
        "channel_name": "Nome del Canale",
        "icons": "Icone",
        "or": "o",
        "only_share_with": "Condividi solo con",
        "private_channel": "Canale Privato",
        "msg2": "Solo i membri e i ruoli selezionati potranno visualizzare questo canale",
        "allowmsg2": "Consente ai membri di inviare messaggi in questo canale",
        "send_messages": "Invia Messaggi",
        "choose_to_upload": "Scegli un'Immagine da Caricare",
        "private_channel_limit_reached": "Hai raggiunto il limite di creazione canali privati. Puoi solo creare canali pubblici. Se desideri creare un canale privato, aggiorna il tuo piano.",
        "public_channel_limit_reached": "Hai raggiunto il limite di creazione canali pubblici. Puoi solo creare canali privati. Se desideri creare un canale pubblico, aggiorna il tuo piano."
    },
    "Templates": {
        "delete_template": "Elimina Modello",
        "project_status": "Stato del Progetto",
        "task_status": "Stato del Compito",
        "no_app_selected": "Nessuna App Selezionata",
        "default_views": "Impostazioni Predefinite per le Vista",
        "apps": "App",
        "add_new_templete": "Aggiungi Nuovo Modello",
        "templates": "Modelli",
        "s": "s",
        "template_name": "Nome del Modello",
        "upload_image": "Carica Immagine",
        "all_good": "Tutto a posto",
        "create_template": "Crea Modello",
        "new_template": "Nuovo Modello",
        "remove": "Rimuovi",
        "enable_apps": "Abilita App",
        "Turn": "Accendi",
        "all_apps": "tutte le App",
        "off": "spento",
        "on": "acceso",
        "upload": "Carica",
        "save_template": "Salva Modello",
        "setup_status": "Configura gli stati per i compiti",
        "what_task": "Quale stato del compito vuoi?",
        "select_task_status": "Seleziona Stato del Compito",
        "delete_template_confirmation": "Sei sicuro di voler eliminare il modello?",
        "ai_sidebar_title": "Crea modello con l'IA",
        "ai_label_category": "Categoria",
        "ai_label_description": "Descrizione",
        "ai_button_text_requested_changes": "Richiedi modifiche",
        "ai_min_view_msg_text": "È necessaria almeno una visualizzazione",
        "ai_min_msg_text": "Sono richiesti almeno 10 caratteri",
        "ai_before_desc_placeholder": "Inserisci la descrizione del caso d'uso per generare il modello",
        "ai_after_desc_placeholder": "Qui puoi continuare a chiedere modifiche pertinenti",
        "try_with_ai": "Prova con l'IA",
        "msg_search_result_found": "Ecco alcuni modelli suggeriti pertinenti alle tue esigenze. Puoi selezionarne uno oppure fare clic per crearne uno con l'IA",
        "msg_search_result_not_found": "Nessun modello pertinente trovato. Per crearne uno con l'IA, fai semplicemente clic"
    },
    "Settings": {
        "add_new_projects": "Aggiungi Nuovo Progetto",
        "task_priority": "Priorità del Compito",
        "maximum_image_size": "Dimensione massima dell'immagine",
        "warning": "Avviso",
        "cant_delete": "non può essere eliminato",
        "priority_in_use": "L'utente non può eliminare la priorità PRIORITY_NAME poiché è già in uso.",
        "company_name": "Nome della Compagnia",
        "phone": "Telefono",
        "country": "Paese",
        "state": "Stato",
        "city": "Città",
        "select_date_format": "Seleziona Formato Data",
        "save_changes": "Salva Modifiche",
        "currencies": "Valute",
        "add_remove_cur": "Aggiungi/Rimuovi Valute",
        "change_image": "Cambia Immagine",
        "Priorities_already_Exists": "Le priorità esistono già",
        "The_priority_image_field_is_required": "Il campo immagine priorità è obbligatorio",
        "The_priority_name_field_is_required": "Il campo nome priorità è obbligatorio",
        "The_priority_name_field_must_be_at_least": "Il campo nome priorità deve contenere almeno 3 caratteri",
        "The file extension field is required": "Il campo estensione file è obbligatorio",
        "The_file_extension_field_must_be_at_least": "Il campo estensione file deve contenere almeno 3 caratteri",
        "file_extension_is_not_supported": "Estensione del file non supportata",
        "file_extension_already_Exists": "L'estensione del file esiste già",
        "The_file_extension_field_is_required": "Il campo estensione file è obbligatorio."
    },
    "Members": {
        "invite": "Invita",
        "all_members": "Tutti i membri",
        "removed_members": "Membri rimossi",
        "name": "Nome",
        "role": "Ruolo",
        "last_active": "Ultima attività",
        "time_tracker": "Tracciatore di Tempo",
        "settings": "Impostazioni",
        "removeuser": "Rimuovi Utente",
        "adduser": "Aggiungi Utente",
        "invite_user": "Invita Utente",
        "remove_request": "Rimuovi Richiesta",
        "resend_invitation": "Rinvita",
        "cancel_invitation": "Annulla Invito",
        "Invitation_mail_sent_sucessfully": "Mail di invito inviata con successo",
        "confirm_change_user_designation": "Sei sicuro di voler cambiare la designazione di questo utente in",
        "confirm_change_user_role": "Sei sicuro di voler cambiare il ruolo di questo utente in",
        "Import_users_from_csv": " Importa utenti da CSV"
    },
    "Upgrades": {
        "take_next_step": "Fai il prossimo passo con il tuo lavoro",
        "you_are_on": "Sei attualmente sul",
        "per_year": "All'anno",
        "per_month": "Al mese",
        "current_plane": "Piano Attuale",
        "per_member": "Per Membro",
        "and_much_more": "e molto altro",
        "upgrade_to": "Aggiorna a",
        "select_payment_method": "Seleziona Metodo di Pagamento",
        "plan": "Piano",
        "plane_upgrade": "Aggiornamento Piano riuscito",
        "plane_upgrade_msg": "Aggiornamento Piano Riuscito! Il tuo abbonamento è stato aggiornato. Attendi 2-3 minuti affinché le modifiche abbiano effetto ovunque, garantendoti di poter godere pienamente delle nuove funzionalità e miglioramenti!",
        "something_wrong": "Qualcosa è andato storto. Per favore riprova",
        "unsucessfull_msg": "Aggiornamento Piano Non riuscito. Abbiamo riscontrato un problema durante l'aggiornamento del tuo piano. Riprova o contatta l'assistenza per aiuto.",
        "upgrade_your_plan": "Aggiorna il tuo Piano",
        "to_unlock_custom_field": "Per sbloccare il Campo Personalizzato",
        "unlimited": "Illimitato",
        "the_feature_not_available": "Quella funzionalità non è disponibile nel tuo piano attuale",
        "unlock_project_permission": "Per sbloccare i Permessi del Progetto",
        "unlock_custom_field": "Per sbloccare il Campo Personalizzato",
        "to_unlock_milestone": "Per sbloccare il Milestone",
        "to_unlock_milestone_report": "Per sbloccare il Rapporto Milestone",
        "to_unlock_security": "Per sbloccare la Sicurezza e i Permessi",
        "to_unlock_team": "Sbloccare la squadra",
        "to_unlcok_project": "Per sbloccare il Progetto",
        "You_have_reached_the_free_plan_limit": "Hai raggiunto il limite di PLAN_NAM",
        "require_upgrade_message": "Puoi creare fino a PROJECT_COUNT progetti con il piano PROJECT_NAME. Crea più bacheche aggiornando il tuo piano.",
        "are_you_sure_you_want_to_update": "Sei sicuro di voler aggiornare?",
        "find_out_whats_included_in_this_update": "Scopri cosa è incluso in questo aggiornamento",
        "improved_performance": "Prestazioni Migliorate",
        "install_now": "Installa Ora",
        "later": "Più tardi",
        "please_see_below_for_a_list_of_changes_to_the_features": "Per favore, consulta qui sotto un elenco delle modifiche alle funzionalità.",
        "to_integrate_new_services_into_an_alian_hub": "Per integrare nuovi servizi in Hyphen OI Pro.",
        "whats_new": "Cosa c'è di nuovo?",
        "check_to_agree_with_above_points": "Seleziona per accettare i punti sopra",
        "general_notes": "Note Generali",
        "update_now": "Aggiorna Ora",
        "unlock_channel": "Per sbloccare il Canale",
        "unlock_chat": "Per sbloccare la Chat",
        "unlock_one_chat": "Per sbloccare la Chat Individuale",
        "public_private_creation_time_limit_reached": "Hai raggiunto il limite per la creazione di progetti. Se desideri creare un progetto, aggiorna il tuo piano.",
        "public_creation_time_limit_reached": "Hai raggiunto il limite per la creazione di progetti pubblici. Puoi creare solo progetti privati. Se desideri creare un progetto pubblico, aggiorna il tuo piano.",
        "private_creation_time_limit_reached": "Hai raggiunto il limite per la creazione di progetti privati. Puoi creare solo progetti pubblici. Se desideri creare un progetto privato, aggiorna il tuo piano."
    },
    "Permissions": {
        "advanced_permission": "Permessi Avanzati",
        "allow_admins": "Permetti agli amministratori di gestire gli spazi privati",
        "when_admin_enable": "Quando abilitato, gli amministratori potranno aggiungere/rimuovere persone e trasferire la proprietà di tutti gli spazi.",
        "show_all_projects": "Mostra tutti i progetti",
        "when_user_enable": "Quando abilitato, gli utenti potranno vedere tutti i progetti globali.",
        "show_all_task": "Mostra tutti i compiti",
        "when_user_enable_sprint": "Quando abilitato, gli utenti potranno vedere tutti i compiti nelle sprint.",
        "own": "Proprio",
        "select": "Seleziona",
        "Member": "Membro",
        "Guest": "Ospite",
        "None": "Nessuno",
        "Read": "Leggi",
        "add_new_team": "Aggiungi Nuovo Team",
        "Read & Write": "Leggi & Scrivi",
        "Support": "Supporto",
        "select_priorities": "Seleziona Priorità",
        "apply_permission": "Applica Permesso",
        "project_permission_description": "Per sovrascrivere i permessi globali, è disabilitato per impostazione predefinita. Dopo che è abilitato, puoi gestire i permessi di progetto e compito. Se è disabilitato, i permessi globali vengono applicati.",
        "project_permission_title_disable": "La possibilità di concedere permessi personalizzati per questo progetto sarà disabilitata",
        "project_permission_title_enable": "La possibilità di concedere permessi personalizzati per questo progetto sarà abilitata",
        "reset_permission": "Reimposta Permesso"
    },
    "subProjectRulesNames": {
        "Project_List": "Elenco Progetti",
        "Project_Create": "Crea Progetto",
        "Project_Name_Edit": "Modifica Nome Progetto",
        "Project_Sprint_Create": "Crea Sprint Progetto",
        "Project_folder_Create": "Crea Cartella Progetto",
        "Project_folder_Name_Edit": "Modifica Nome Cartella Progetto",
        "Project_sprint_Name_Edit": "Modifica Nome Sprint Progetto",
        "Project_Details": "Dettagli Progetto",
        "Project_Status_Change": "Cambia Stato Progetto",
        "Project_Assignee": "Assegnatario Progetto",
        "Project_Category": "Categoria Progetto",
        "Proejct_Source": "Fonte Progetto",
        "Project_Type": "Tipo Progetto",
        "Project_Currency": "Valuta Progetto",
        "Project_Amount": "Importo Progetto",
        "Project_Start Date": "Data Inizio Progetto",
        "Project_End Date": "Data Fine Progetto",
        "Project_Due Date": "Data Scadenza Progetto",
        "Project_Close": "Chiudi Progetto",
        "Project_Description": "Descrizione Progetto",
        "Project_Checklist": "Checklist Progetto",
        "Project_Checklist_Assign/remove": "Assegna/rimuovi Checklist Progetto",
        "Project_Attachments": "Allegati Progetto",
        "Project_Milestone": "Traguardo Progetto",
        "Task_list": "Elenco Compiti",
        "Task_Create": "Crea Compito",
        "Sub_Task_Create": "Crea Sottocompito",
        "Task_Name_Edit": "Modifica Nome Compito",
        "Task_Status": "Stato Compito",
        "Task_Assignee": "Assegnatario Compito",
        "Task_Priority": "Priorità Compito",
        "Task_Due_Date": "Data Scadenza Compito",
        "Task_Estimated_Hours": "Ore Stimate Compito",
        "Task_Description": "Descrizione Compito",
        "Task_Checklist": "Checklist Compito",
        "Task_Checklist_Assign/remove": "Assegna/rimuovi Checklist Compito",
        "Task_Attachments": "Allegati Compito",
        "Show_Tasks": "Mostra Compiti",
        "Custom_Field": "Campo Personalizzato",
        "Edit_Company": "Modifica Azienda",
        "File_Extensions": "Estensioni File",
        "Project_Milestone_Status": "Stato Traguardo Progetto",
        "Invite_Member": "Invita Membro",
        "Member_list": "Elenco Membri",
        "Create_Team": "Crea Team",
        "Team_List": "Elenco Team",
        "Security_&_Permissions": "Sicurezza e Permessi",
        "Role_Management": "Gestione Ruoli",
        "Designation": "Designazione",
        "Milestone_Weekly_Range": "Intervallo Settimanale Traguardo",
        "User_Timesheet": "Foglio Ore Utente",
        "Project_Timesheet": "Foglio Ore Progetto",
        "Workload__Timesheet": "Foglio Ore Carico di Lavoro",
        "Milestone_Report": "Rapporto Traguardo",
        "Project": "Progetto",
        "Task": "Compito",
        "Company_Settings": "Impostazioni Azienda",
        "Sheet_Settings": "Impostazioni Foglio",
        "Team_Color": "Colore Team",
        "Team_Name": "Nome Team",
        "Add_Member": "Aggiungi Membro",
        "Add_New_Designation": "Aggiungi Nuova Designazione"
    },
    "Notification": {
        "Notification": "Notifica",
        "notification_setting": "Impostazioni Notifiche",
        "browser": "Browser",
        "mobile": "Mobile",
        "before": "Prima",
        "chat": "Chat",
        "project": "Progetto",
        "tasks": "Compiti",
        "before_project_due_date": "Data di Scadenza Progetto",
        "before_project_end_date": "Data Fine Progetto",
        "before_task_due_date": "Data di Scadenza Compito",
        "before_task_end_date": "Data Fine Compito",
        "message_create": "Crea Messaggio",
        "project_create": "Crea Progetto",
        "project_name": "Nome Progetto",
        "project_status_change": "Cambia Stato Progetto",
        "project_assignee": "Assegnatario Progetto",
        "project_lead": "Responsabile Progetto",
        "project_category": "Categoria Progetto",
        "project_source": "Fonte Progetto",
        "project_type": "Tipo Progetto",
        "project_currency": "Valuta Progetto",
        "project_amount": "Importo Progetto",
        "project_start_date": "Data Inizio Progetto",
        "project_end_date": "Data Fine Progetto",
        "project_due_date": "Data di Scadenza Progetto",
        "project_close": "Chiudi Progetto",
        "project_description": "Descrizione Progetto",
        "project_checklist": "Checklist Progetto",
        "project_checklist_assign": "Assegna Checklist Progetto",
        "project_checklist_remove": "Rimuovi Checklist Progetto",
        "project_attachments": "Allegati Progetto",
        "project_milestone": "Traguardo Progetto",
        "project_milestone_status_change": "Cambia Stato Traguardo Progetto",
        "project_sprint_create": "Crea Sprint Progetto",
        "project_folder_create": "Crea Cartella Progetto",
        "comments_im_@mentioned_in": "Commenti in cui sono stato menzionato",
        "task_notification": "Notifica Compito",
        "task_create": "Crea Compito",
        "task_edit": "Modifica Compito",
        "task_status": "Stato Compito",
        "task_assignee": "Assegnatario Compito",
        "task_priority": "Priorità Compito",
        "task_type": "Tipo Compito",
        "task_due_date": "Data Scadenza Compito",
        "task_description": "Descrizione Compito",
        "task_checklist": "Checklist Compito",
        "task_checklist_assign": "Assegna Checklist Compito",
        "task_checklist_remove": "Rimuovi Checklist Compito",
        "task_attachments": "Allegati Compito",
        "comments_Im_@mentioned_in": "Commenti in cui sono stato menzionato",
        "logged_hours_notification": "Notifica Ore Registrate",
        "after_3_hours_today_pending_hours": "Notifica Ore Pendenti Dopo 3 Ore Oggi",
        "task_estimated_hours": "Ore Stimate Compito"
    },
    "TimeTracker": {
        "TimeTracker": "Tracker Tempo",
        "unlock": "Sblocca l'Universo con il Tracker Hyphen OI Pro sul Tuo Desktop!",
        "smooth": "Monitora facilmente le ore spese dagli utenti sui progetti o compiti con il tracking del tempo.",
        "click": "clicca",
        "No_Record_Found": "Nessun Record Trovato",
        "total": "Totale",
        "screenshot_preview": "Anteprima Screenshot",
        "log_time_found_no_screenshot": "Tempo registrato trovato, ma non è stato catturato nessuno screenshot per questa durata."
    },
    "settingslider": {
        "Time Tracking": "Monitoraggio Tempo",
        "Notifications": "Notifiche",
        "Company": "Azienda",
        "My Settings": "Le Mie Impostazioni",
        "Security & Permissions": "Sicurezza e Permessi",
        "Upgrade": "Aggiorna",
        "Custom Field Manager": "Gestione Campi Personalizzati",
        "Templates": "Modelli",
        "Projects": "Progetti",
        "Teams": "Team",
        "Members": "Membri",
        "Settings": "Impostazioni",
        "Change Password": "Cambiare la password"
    },
    "Chat": {
        "welcome_message": "Benvenuto su BRAND_NAME",
        "msg2": "Questo è un nuovo gruppo. Ecco alcuni passaggi per aiutarti a iniziare. Per ulteriori informazioni, consulta la nostra guida per iniziare",
        "chats": "Chat",
        "favorites": "Preferiti",
        "CHANNELS": "CANALI"
    },
    "Comments": {
        "unread_message": "Messaggi non letti",
        "more": "più",
        "less": "meno",
        "edited": "modificato",
        "edit": "Modifica",
        "create_task": "Crea Compito",
        "add_to_checklist": "Aggiungi alla Checklist",
        "copy_message": "Copia Messaggio",
        "reply": "Rispondi",
        "message": "Messaggio",
        "mark_unread": "Segna come non letto",
        "This_message_is_deleted": "Questo messaggio è stato eliminato",
        "You_deleted_this_message": "Hai eliminato questo messaggio",
        "no_user_found": "Nessun utente trovato",
        "unlock_comment_view": "Sblocca la vista del commento"
    },
    "PlaceHolder": {
        "enter_task_type": "Inserisci Tipo di Compito",
        "enter_task_status": "Inserisci Stato del Compito",
        "enter_project_status": "Inserisci Stato del Progetto",
        "Enter_Project_Name": "Inserisci Nome Progetto",
        "Enter_Key_Name": "Inserisci Nome Chiave",
        "Select_Category": "Seleziona Categoria",
        "Select_Project_Due_Date": "Seleziona Data di Scadenza del Progetto",
        "search": "Cerca",
        "search_here": "Cerca qui",
        "Type_here": "Scrivi qui",
        "Task_name": "Nome Compito",
        "Add_description": "Aggiungi descrizione",
        "Enter_Duplicate_Task_Name": "Inserisci Nome Compito Duplicato",
        "Enter_Text": "Inserisci Testo",
        "Enter_Amount": "Inserisci Importo",
        "Select": "Seleziona",
        "Enter_Refund_Amount": "Inserisci Importo Rimborso",
        "Enter_Milestone_Name": "Inserisci Nome Traguardo",
        "Enter_sprint_name": "Inserisci Nome Sprint",
        "Enter_directory_name": "Inserisci Nome Directory",
        "Rename_Tag": "Rinomina Tag",
        "Enter_Team_Name": "Inserisci Nome Team",
        "Duration_only_hours": "Durata solo in ore",
        "Enter_option": "Inserisci opzione",
        "Enter_View_Name": "Inserisci Nome Vista",
        "Enter_URL": "Inserisci URL",
        "Enter_HTML": "Inserisci HTML",
        "Enter_item_name": "+ Inserisci nome elemento",
        "Add_an_item": "+ Aggiungi un elemento",
        "Enter_Company_Name": "Inserisci Nome Azienda",
        "Select_Country": "Seleziona Paese",
        "Enter_Template": "Inserisci Modello",
        "Enter_Template_Name": "Inserisci Nome Modello",
        "Project_key_must_be_unique": "La chiave del progetto deve essere unica",
        "Enter_zip": "Inserisci CAP",
        "Enter_GST_Number": "Inserisci Numero GST",
        "Enter_Milestone_Status": "Inserisci Stato Traguardo",
        "Enter_Priority_Name": "Inserisci Nome Priorità",
        "Enter_File_Extensions_Name": "Inserisci Nome Estensioni File",
        "Enter_Task_Name": "Inserisci Nome Compito",
        "Select_State": "Seleziona Stato",
        "No_States": "Nessuno Stato",
        "Select_City": "Seleziona Città",
        "No_Cities": "Nessuna Città",
        "enter_category_name": "Inserisci Nome Categoria",
        "enter_channel_name": "Inserisci Nome Canale",
        "Pinned_messages": "Messaggi Fissati",
        "Search": "Cerca",
        "Search_by_name_or_email": "Cerca per nome o email",
        "Invite_by_email": "Invita via email",
        "Select_Designation": "Seleziona Designazione",
        "Select_Role": "Seleziona Ruolo",
        "Enter_designation": "Inserisci Designazione",
        "Enter_Description": "Inserisci Descrizione",
        "Add_New_Role": "Aggiungi Nuovo Ruolo",
        "Enter_role": "Inserisci ruolo",
        "Enter_Field_Label": "Inserisci Etichetta Campo",
        "Enter_Placeholder": "Inserisci Segnaposto",
        "field_label": "Etichetta Campo",
        "placeholder": "Segnaposto",
        "Enter_Number": "Inserisci Numero"
    },
    "DuplicateTask": {
        "duplicate_task_name": "Nome Compito Duplicato",
        "what_do_you_copy": "Cosa vuoi copiare",
        "everything": "Tutto",
        "no_assignee": "Nessun Assegnatario",
        "no_watcher": "Nessun Osservatore",
        "move_task": "Sposta Compito",
        "mearge_task_into": "Unisci Compito in"
    },
    "Converttolist": {
        "are_you_sure_convert": "Sei sicuro di voler convertire questo compito in una Lista?",
        "important": "Importante",
        "you_will_lose": "Perderai tutti i commenti a thread. Questa azione non può essere annullata",
        "convert_to_list": "Converti in lista"
    },
    "Billing": {
        "billing_details": "Dettagli di Fatturazione",
        "plan_details": "Dettagli Piano",
        "next_msg": "L'importo successivo da pagare è",
        "due_on": "Scade il",
        "upgrade_plan": "Aggiorna Piano",
        "cancel_subscription": "Annulla Abbonamento",
        "reactivate_subscription": "Riattiva Abbonamento",
        "biling_info": "Informazioni di Fatturazione",
        "update_billing_info": "Aggiorna Informazioni di Fatturazione",
        "contact_support": "Contatta Supporto",
        "for_help_msg": "Per assistenza e domande sulla fatturazione, contatta il nostro team di supporto che sarà felice di aiutarti.",
        "payment_methods": "Metodi di Pagamento",
        "update_payment_method": "Aggiorna Metodo di Pagamento",
        "add_payment_method": "Aggiungi metodo di pagamento",
        "ending_in": "che scade il",
        "payment_method_update": "Aggiornamento metodo di pagamento avvenuto con successo.",
        "waiting_msg": "Il recente aggiornamento del tuo metodo di pagamento avrà effetto con la tua prossima fattura e sarà utilizzato per tutti i pagamenti futuri.",
        "error_updating": "Aggiornamento metodo di pagamento non riuscito. Si è verificato un problema durante l'aggiornamento del tuo metodo di pagamento. Riprova o contatta il supporto per assistenza.",
        "card_expires": "La carta scade il",
        "billing_address": "Indirizzo di Fatturazione",
        "subscription_plan": "Piano di Abbonamento",
        "next_renew_date": "Prossima Data di Rinnovo",
        "storage_use": "Utilizzo dello Spazio di Archiviazione",
        "address": "Indirizzo",
        "address_line": "Linea Indirizzo",
        "zip_code": "CAP",
        "zip": "CAP",
        "Save_&_Continue": "Salva e Continua",
        "billing_history": "Storico Fatturazione",
        "Invoices": "Fatture",
        "credit_notes": "Note di Credito",
        "download": "Scarica",
        "id": "ID",
        "type": "Tipo",
        "date": "Data",
        "description": "Descrizione",
        "no_of_users": "Numero di Utenti",
        "amount": "Importo",
        "status": "Stato",
        "pay_now": "Paga Ora",
        "cancelling_subscription_message": "Annullare l'abbonamento significa che il tuo abbonamento terminerà il",
        "reactivate_anytime": "Puoi riattivarlo in qualsiasi momento prima di quella data!",
        "reactivate_confirmation": "Sei sicuro di voler riattivare l'abbonamento? Se selezioni 'Sì', riattiverai e riprenderai il tuo programma di fatturazione.",
        "amounting_to": "pari a",
        "insufficient_funds": "Fondi Insufficienti",
        "payment_successful": "Pagamento riuscito.",
        "payment_successful_details": "Pagamento riuscito! La tua fattura è stata pagata. Attendi 2-3 minuti affinché le modifiche abbiano effetto ovunque, garantendo che tu possa godere appieno delle funzionalità e miglioramenti ampliati!",
        "payment_unsuccessful": "Pagamento non riuscito. Si è verificato un problema durante l'aggiornamento del piano. Riprova o contatta il supporto per assistenza.",
        "plan_upgrade_unsuccessful": "Aggiornamento Piano non riuscito. Si è verificato un problema durante l'aggiornamento del piano. Assicurati che la carta abbia un saldo sufficiente.",
        "proceed_with_payment": "Vuoi procedere con il pagamento per la fattura numero",
        "attention_needed": "Abbiamo bisogno della tua attenzione!",
        "avoid_service_disruption": "per evitare interruzioni del servizio",
        "subscription_renewal_failed": "Il rinnovo automatico dell'abbonamento è fallito a causa di",
        "update_payment_method_please": "Aggiorna il tuo metodo di pagamento",
        "click_here_for_update_payment_method": "Clicca qui per aggiornare il metodo di pagamento",
        "credit_balance": "Saldo di Credito",
        "this_balance_will_be_used_for_a_future_payment": "Questo saldo verrà utilizzato per un pagamento futuro.",
        "paymnet_failed_subscription_canceled": "Vogliamo informarti che il tuo precedente abbonamento è stato annullato. Il tuo account è stato ora trasferito al nostro abbonamento predefinito, che ha alcune funzionalità disabilitate. Per abilitare queste funzionalità, aggiorna il tuo piano.",
        "promotional_credit_balance": "Credito promozionale",
        "balance": "Saldo",
        "created_on": "Creato il",
        "no_promotional_found": "Nessuna cronologia di credito promozionale trovata"
    },
    "Tour": {
        "tour_completed": "Tour Completato",
        "do_you_have_any": "Hai domande? Ti incoraggiamo a esplorare i nostri tutorial video completi di BRAND_NAME per iniziare e sfruttare al massimo la tua esperienza.",
        "watch_video": "Guarda il Video",
        "have_brief_tour_alianhub": "Fai un breve tour di BRAND_NAME?",
        "have_brief_tour_alianhub_view": "Fai un breve tour delle viste di BRAND_NAME?",
        "have_brief_tour_alianhub_left_side": "Fai un breve tour della lista dei progetti?",
        "look_how_to_create": "Guarda come creare un progetto, gestire i compiti, visualizzare i report delle ore, entrare in una chat, visualizzare le menzioni e le notifiche, e altro ancora.",
        "lets_start": "Iniziamo",
        "no_thanks": "No, grazie",
        "have_brief_task": "Fai un breve tour del Compito?",
        "have_brief_tour_project": "Fai un breve tour del progetto?",
        "look_how_to_create_task": "Guarda come creare un compito, gestire il compito, visualizzare il compito in base al gruppo di stato e altro.",
        "look_how_to_create_project": "Guarda come creare un progetto, gestire il progetto, visualizzare il compito in base al gruppo di stato e altro.",
        "project_creation_description": "I progetti possono essere creati, assegnati e monitorati senza sforzo, con una chiara visibilità delle responsabilità per i membri del team. Questo promuove una migliore organizzazione, migliorando l'efficienza e la produttività. Clicca qui per avviare un nuovo progetto.",
        "enter_project_name": "Inserisci un nome breve per il tuo progetto.",
        "enter_project_key": "Inserisci una chiave breve per il tuo progetto.",
        "add_project_category": "Aggiungi una categoria per il tuo progetto.",
        "enter_project_duedate": "Inserisci una data di scadenza per il tuo progetto.",
        "add_project_lead_assignee": "Aggiungi il lead assignee per il tuo progetto.",
        "create_project_from_template": "Questa opzione ti consente di creare rapidamente un nuovo progetto utilizzando un modello esistente, che include dati e impostazioni preconfigurate, permettendoti di replicare facilmente la stessa configurazione del progetto.",
        "customize_project_section": "Questa opzione ti consente di personalizzare completamente il tuo progetto configurando vari elementi come stati, tipi, app e altro, su misura per soddisfare le tue esigenze specifiche.",
        "task_type_templates_list_text": "Elenco dei Modelli di Tipo di Compito",
        "task_type_templates_description_text": "Questa sezione mostra i modelli di tipo di compito disponibili. Seleziona quello che soddisfa le tue esigenze.",
        "create_new_task_type_template_text": "Crea Nuovo Modello di Tipo di Compito",
        "create_new_task_type_template_description_text": "Clicca sul pulsante + per aggiungere un nuovo modello di tipo di compito, che poi potrai usare per i tuoi compiti.",
        "view_template_task_types_text": "Visualizza i Tipi di Compito del Modello",
        "view_template_task_types_description_text": "Qui puoi vedere i tipi di compito legati al modello selezionato. Puoi modificare o aggiungere nuovi tipi di compito in base alle tue necessità.",
        "add_new_task_type_text": "Aggiungi Nuovo Tipo di Compito",
        "add_new_task_type_description_text": "Clicca sul pulsante 'Aggiungi Tipo di Compito' per inserire nuovi tipi di compito nel modello selezionato.",
        "save_project_as_template_text": "Salva il Progetto come Modello",
        "save_project_as_template_description_text": "Clicca su 'Salva come Modello' per archiviare la configurazione attuale da utilizzare in progetti futuri.",
        "initiate_new_project_text": "Avvia Nuovo Progetto",
        "initiate_new_project_description_text": "Clicca qui per avviare un nuovo progetto.",
        "add_new_task_text": "Aggiungi Nuovo Compito",
        "input_task_name_text": "Inserisci Nome Compito",
        "choose_task_status_text": "Scegli Stato Compito",
        "assign_task_text": "Assegna Compito",
        "set_task_deadline_text": "Imposta Scadenza Compito",
        "define_task_priority_text": "Definisci Priorità Compito",
        "view_task_list_text": "Visualizza Lista Compiti",
        "task_information_text": "Informazioni Compito",
        "quick_task_menu_text": "Menu Rapido Compito",
        "task_actions_text": "Azioni Compito",
        "subtask_toggle_text": "Attiva/Subtask",
        "task_tour_complete_text": "Tour del Compito Completato",
        "create_new_task_description_text": "Crea un nuovo compito cliccando sul pulsante '+ Nuovo Compito'.",
        "input_task_name_description_text": "Inserisci il nome del compito nel campo fornito.",
        "choose_task_status_description_text": "Seleziona il tipo di compito appropriato in base alle tue necessità.",
        "assign_task_description_text": "Seleziona la persona a cui sarà assegnato il compito.",
        "set_task_deadline_description_text": "Scegli una data di scadenza per il compito.",
        "define_task_priority_description_text": "Scegli il livello di priorità per il compito.",
        "view_task_list_description_text": "Questa è una lista di compiti, con i loro dettagli e raggruppati per stato.",
        "task_information_description_text": "Qui sono riportati i dettagli del compito selezionato.",
        "quick_task_menu_description_text": "Cliccando sull'icona si aprirà un menu a tendina con le opzioni delle operazioni sul compito.",
        "task_actions_description_text": "Seleziona un'azione dalla lista delle operazioni disponibili sul compito.",
        "subtask_toggle_description_text": "Qui c'è l'opzione per visualizzare la lista dei sottocompiti.",
        "task_tour_complete_description_text": "Il tour è terminato. Inizia a esplorare le molte possibilità che ti aspettano!",
        "search_and_filter_projects_text": "Cerca e Filtra Progetti",
        "search_projects_text": "Cerca Progetti",
        "search_options_for_projects_text": "Opzioni di Ricerca per i Progetti",
        "search_projects_by_name_text": "Cerca progetti per nome",
        "advanced_project_search_text": "Ricerca avanzata dei progetti",
        "filter_projects_by_favorites_text": "Filtra i progetti per preferiti",
        "project_settings_text": "Impostazioni del progetto",
        "project_list_text": "Elenco dei progetti",
        "end_of_project_view_tour_text": "Fine del tour visualizzazione progetto",
        "search_and_filter_projects_description_text": "Cerca e filtra i progetti in base ai tuoi criteri qui.",
        "enter_search_keywords_text": "Inserisci parole chiave per trovare progetti specifici.",
        "search_filter_dropdown_description_text": "Fai clic sull'icona per aprire un menu a discesa con i filtri di ricerca.",
        "toggle_search_options_description_text": "Alterna tra le opzioni per cercare per progetto, sprint o cartella mentre scrivi.",
        "advanced_search_icon_description_text": "Fai clic sull'icona per eseguire un'operazione di ricerca avanzata.",
        "filter_by_favorites_description_text": "Fai clic sull'icona della stella per dare priorità ai tuoi progetti preferiti in cima all'elenco.",
        "project_settings_icon_description_text": "Fai clic sull'icona delle impostazioni per passare tra le opzioni di progetto archiviato o non archiviato.",
        "view_project_list_description_text": "Qui puoi visualizzare l'elenco dei tuoi progetti.",
        "end_of_project_view_tour_description_text": "Il tour è ora completo.",
        "create_assign_prioritize_monitor_projects_text": "Crea facilmente, assegna, dai priorità e monitora i progetti. I membri del team possono visualizzare chiaramente le loro attività, rimanere organizzati e migliorare l'efficienza e la produttività. Fai clic qui per iniziare un nuovo progetto.",
        "track_users_time_sheet_reports_text": "Traccia efficacemente il tempo degli utenti con vari report delle schede orarie, come la scheda oraria utente, la scheda oraria progetto, la scheda oraria carico di lavoro e la scheda oraria tracker. Fai clic qui per esplorare i report delle schede orarie.",
        "user_time_sheet_description_text": "La scheda oraria utente ti consente di monitorare le ore registrate da ciascun utente in base al tuo ruolo utente.",
        "project_time_sheet_description_text": "Monitora le ore registrate per ciascun progetto nella scheda oraria del progetto in base al tuo ruolo utente.",
        "workload_time_sheet_description_text": "Simile alla scheda oraria utente, la scheda oraria del carico di lavoro include anche dettagli sul carico di lavoro dell'utente, le ore totali e le ore stimate.",
        "tracker_sheet_description_text": "La scheda tracker mostra il tempo registrato tramite il tracker del tempo, insieme agli screenshot e al tempo totale registrato.",
        "view_companies_switch_text": "Visualizza tutte le aziende con cui sei associato e passa facilmente tra di esse selezionandone una.",
        "engage_team_real_time_text": "Interagisci con i membri del team in tempo reale per prendere decisioni rapide. Crea canali e condividi informazioni tramite allegati, messaggi vocali e testo.",
        "real_time_notifications_text": "Rimani aggiornato con le notifiche in tempo reale su attività, compiti, assegnazioni, modifiche di stato, commenti e scadenze del progetto.",
        "address_specific_individuals_text": "Indirizza direttamente persone specifiche all'interno del sistema di gestione del progetto. Visualizza le menzioni relative a compiti, progetti o discussioni.",
        "access_personal_information_text": "Accedi alle tue informazioni personali, insieme alle impostazioni relative a aziende, progetti, utenti e sicurezza, in base al tuo ruolo utente.",
        "project_views_list_text": "Elenco delle visualizzazioni del progetto",
        "add_new_project_view_text": "Aggiungi nuova visualizzazione progetto",
        "manage_project_views_text": "Gestisci le visualizzazioni del progetto",
        "project_files_text": "File del progetto",
        "project_audio_files_text": "File audio del progetto",
        "add_project_watcher_text": "Aggiungi osservatore progetto",
        "project_operation_list_text": "Elenco operazioni progetto",
        "advanced_task_filter_text": "Filtro avanzato delle attività",
        "search_tasks_text": "Cerca compiti",
        "search_options_menu_text": "Menu opzioni di ricerca",
        "search_criteria_text": "Criteri di ricerca",
        "project_views_list_description_text": "Un elenco delle visualizzazioni del progetto disponibili.",
        "add_new_project_view_description_text": "Crea una nuova visualizzazione qui.",
        "manage_project_views_description_text": "Qui puoi aggiungere o fissare le visualizzazioni a un progetto. Fai clic su 'Aggiungi visualizzazione' per aggiungere, o seleziona 'Fissa visualizzazione' per fissare una visualizzazione.",
        "project_files_description_text": "Accedi a tutti i file e ai link del progetto facendo clic sull'icona.",
        "project_audio_files_description_text": "Fai clic sull'icona per visualizzare tutti i file audio relativi al progetto.",
        "add_project_watcher_description_text": "Gestisci le impostazioni del tuo osservatore del progetto.",
        "project_operation_list_description_text": "Esegui varie operazioni sul progetto da qui.",
        "advanced_task_filter_description_text": "Fai clic sull'icona per eseguire un'operazione di ricerca avanzata.",
        "search_tasks_description_text": "Inserisci parole chiave rilevanti per cercare compiti specifici.",
        "search_options_menu_description_text": "Fai clic sull'icona per aprire un menu a discesa con diverse opzioni di ricerca.",
        "search_criteria_description_text": "Scegli tra nome compito, chiave compito o descrizione per perfezionare la tua ricerca mentre scrivi.",
        "select_operation_description_text": "Seleziona un'operazione dall'elenco per eseguire l'azione desiderata sul progetto."
    },
    "TaskStatus": {
        "To_Do": "Da fare"
    },
    "AI": {
        "generate": "Genera",
        "ai_button": "Scrivi con l'AI",
        "ai_title": "Chiedi all'AI di trovare o creare qualsiasi cosa",
        "write_with_ai": "Scrivi con l'AI",
        "suggest_tasks": "Suggerisci compiti",
        "suggest_subtasks": "Suggerisci sotto-compiti",
        "ai_sidebar_placeholder": "Di cosa vorresti che l'AI scrivesse?",
        "ai_chat_placeholder": "Dì all'AI cosa fare successivamente",
        "ai_available_on_paid_plans_upgrade_now": "L'AI è disponibile solo per l'acquisto nei nostri piani a pagamento. Aggiorna e aggiungi l'AI ora!",
        "please_upgrade_plan_to_use_ai": "Aggiorna il tuo piano per utilizzare l'AI.",
        "read_less": "Leggi meno",
        "read_more": "Leggi di più",
        "to_unlock_ai": "Per sbloccare l'AI",
        "copy": "Copia",
        "generating_results": "Generazione dei risultati",
        "hub_ai": "HubAi",
        "regenerate": "Rigenera",
        "title": "Titolo",
        "error_occurred_engine_issue": "Si è verificato un errore. L'engine che hai richiesto non esiste o c'è stato un altro problema nel processare la tua richiesta",
        "ai_not_integrated": "L'AI non è integrata nel tuo sistema",
        "limit_reached": "Hai raggiunto il limite"
    },
    "Toast": {
        "Your_card_is_expired": "La tua carta è scaduta.",
        "Password_set_new_has_been_successfully": "La nuova password è stata impostata con successo.",
        "task_created_successfully": "Task creato con successo",
        "please_remove_the_advanced_filter_to_view_newly_created_projects": "Per favore, rimuovi il filtro avanzato per visualizzare i progetti appena creati.",
        "create_task_plan_limit_message": "Aggiorna il tuo piano. Hai raggiunto il limite per la creazione di task nel sprint TASK_SPRINT.",
        "something_went_wrong": "Qualcosa è andato storto.",
        "file_size_is_larger_than_maxFileSize": "La dimensione del file è maggiore di maxFileSize",
        "Select_image_only_and_image_file_format_should_be_FILE_FORMATS": "Seleziona solo l'immagine e il formato del file immagine deve essere FILE_FORMATS",
        "Select_file_only_image_and_image_file_format_should_be_FILE_FORMATS": "Seleziona solo il file immagine e il formato del file immagine deve essere FILE_FORMATS",
        "Multiple_files_not_allowed": "File multipli non consentiti.",
        "Please_select_valid_file": "Seleziona un file valido.",
        "require_image_format_message": "Il formato del file non è supportato o non è stato aggiunto nelle impostazioni dell'azienda. Puoi aggiungere il formato del file nelle Impostazioni.",
        "You_have_to_add_extension_in_setting": "Devi aggiungere l'estensione nelle impostazioni.",
        "Something_went_wrong_Please_try_again": "Qualcosa è andato storto. Per favore, riprova.",
        "Company_is_disable": "L'azienda è disabilitata",
        "advance_search_feature_upgrade_message": "La funzione di ricerca avanzata non è disponibile nel tuo piano attuale. Per sbloccare la ricerca avanzata, aggiorna il tuo piano.",
        "Access_Denied": "Accesso negato",
        "notification_permission": "Per ricevere notifiche, consenti il permesso di notifica nelle impostazioni del sito e ricarica la pagina.",
        "Link_is_Copied_to_clipboard": "Il link è stato copiato negli appunti",
        "Task_Key_is_Copied_to_clipboard": "La chiave del task è stata copiata negli appunti",
        "At_least_one_field_is_required": "Almeno un campo è richiesto.",
        "Task_name_updated_successfully": "Nome del task aggiornato con successo",
        "Watcher_added_successfully": "Watcher aggiunto con successo",
        "Watcher_removed_successfully": "Watcher rimosso con successo",
        "Nothing_to_update": "Niente da aggiornare",
        "Sprint created successfully": "Sprint creato con successo",
        "Sprint restored successfully": "Sprint ripristinato con successo",
        "Sprint closed successfully": "Sprint chiuso con successo",
        "Sprint archived successfully": "Sprint archiviato con successo",
        "Sprint deleted successfully": "Sprint eliminato con successo",
        "Upgrade_your_plan_you_have_reached_the_limit_for_creating_sprints": "Aggiorna il tuo piano. Hai raggiunto il limite per la creazione di sprint.",
        "Folder created successfully": "Cartella creata con successo",
        "Folder updated successfully": "Cartella aggiornata con successo",
        "Folde restored successfully": "Cartella ripristinata con successo",
        "Folder closed successfully": "Cartella chiusa con successo",
        "Folder archived successfully": "Cartella archiviata con successo",
        "Folder deleted successfully": "Cartella eliminata con successo",
        "Status_changed_successfully": "Stato cambiato con successo",
        "Due_date_updated_successfully": "Data di scadenza aggiornata con successo",
        "Due_date_not_updated": "Data di scadenza non aggiornata",
        "Assignee changed_ successfully": "Assegnatario cambiato con successo",
        "Assignee added successfully": "Assegnatario aggiunto con successo",
        "Assignee removed successfully": "Assegnatario rimosso con successo",
        "Assignee not updated": "Assegnatario non aggiornato",
        "Task_updated_successfully": "Task aggiornato con successo",
        "Task_restored_successfully": "Task ripristinato con successo",
        "Task_archived_successfully": "Task archiviato con successo",
        "Task_deleted_successfully": "Task eliminato con successo",
        "Tag_Deleted_successfully": "Tag eliminato con successo",
        "Log_time_added_successfully": "Tempo di log aggiunto con successo.",
        "Filter_saved_successfully": "Filtro salvato con successo.",
        "Filter_update_successfully": "Filtro aggiornato con successo.",
        "Filter_deleted_successfully": "Filtro eliminato con successo.",
        "Checklist_creted_succesfully.": "Checklist creata con successo.",
        "Please_select_checklist": "Seleziona la checklist.",
        "already_exists": "EXIST_VALUE esiste già",
        "Converted_sucessfully": "Convertito con successo",
        "create_task_limit_in_sprint_upgrade_task_message": "Aggiorna il tuo piano. Hai raggiunto il limite per la creazione di task nello sprint SELECTED_SPRINT_DATA.",
        "Please_Select_Task_Type": "Seleziona il tipo di task",
        "Please_Select_Task": "Seleziona un task",
        "Task_moved_sucessfully": "Task spostato con successo",
        "Task_not_moved": "Task non spostato",
        "Task_duplicate_sucessfully": "Task duplicato con successo",
        "Task_not_duplicated": "Task non duplicato",
        "Convert_in_to_task_sucessfully": "Convertito in task con successo",
        "Company_name_already_exists": "Il nome dell'azienda esiste già",
        "Company_has_been_created_Successfully": "L'azienda è stata creata con successo.",
        "Custom_field_updated_successfully": "Campo personalizzato aggiornato con successo",
        "No_assignee_found": "Nessun assegnatario trovato",
        "No_due_date_found": "Nessuna data di scadenza trovata",
        "No_self_assignee_found": "Nessun assegnatario trovato",
        "Estimated_time_updated_successfully": "Tempo stimato aggiornato con successo",
        "Description_updated_successfully": "Descrizione aggiornata con successo",
        "Description_not_updated": "Descrizione non aggiornata",
        "Copied": "Copiato!",
        "User_removed_successfully": "Utente rimosso con successo",
        "Invitation_cancelled_successfully": "Invito cancellato con successo",
        "User_role_changed_successfully": "Ruolo dell'utente cambiato con successo",
        "User_designation_changed_successfully": "Designazione dell'utente cambiata con successo.",
        "Please_upgrade_your_plan_to_use_Time_Tracker": "Aggiorna il tuo piano per usare il Time Tracker.",
        "Request_remove_successfully": "Richiesta rimossa con successo",
        "Upgrade_Your_Plan": "Aggiorna il tuo piano",
        "Updated_successfully": "Aggiornato con successo",
        "Deleted_successfully": "Eliminato con successo",
        "View_Pinned": "Visualizza fissato",
        "View_Unpinned": "Visualizza non fissato",
        "View_Already_Added": "Visualizza già aggiunto",
        "Company_details_saved_successfully": "Dettagli azienda salvati con successo.",
        "Currency_added_successfully": "Valuta aggiunta con successo",
        "Currency_removed_successfully": "Valuta rimossa con successo",
        "File_extension_remove_successfully": "Estensione del file FILE_EXTENSION rimossa con successo",
        "File_extension_update_successfully": "Estensione file aggiornata con successo.",
        "Status_updated_successfully": "Stato aggiornato con successo",
        "Project_milestone_status_Deleted_successfully": "Stato del traguardo del progetto eliminato con successo.",
        "Milestone_weekly_range_updated_successfully": "Intervallo settimanale del traguardo aggiornato con successo.",
        "Image_dimensions_should_not_exceed_ImageDimensions_pixels": "Le dimensioni dell'immagine non devono superare ImageDimensions pixel.",
        "error_in_uploading_image_please_try_it_again": "Errore nel caricamento dell'immagine, per favore riprova",
        "Task_priority_updated_successfully": "Priorità del task aggiornata con successo.",
        "Task_priority_Remove_successfully": "Priorità del task rimossa con successo.",
        "Priority_updated_successfully": "Priorità aggiornata con successo",
        "Priority_not_updated": "Priorità non aggiornata",
        "error_in_deleting_priority_please_try_it_again": "Errore nell'eliminazione della priorità, per favore riprova",
        "Field_Enable_Successfully": "Campo abilitato con successo",
        "Field_Disable_Successfully": "Campo disabilitato con successo",
        "Field_Added_Successfully": "Campo aggiunto con successo",
        "Field_Updated_Successfully": "Campo aggiornato con successo",
        "Added_to_favourite": "Aggiunto ai preferiti",
        "Removed_from_favourite": "Rimosso dai preferiti",
        "Tag_Created_successfully": "Tag creato con successo",
        "Queue list added successfully": "Lista di coda aggiunta con successo",
        "Queue list removed successfully": "Lista di coda rimossa con successo",
        "Queue list not updated": "Lista di coda non aggiornata",
        "Attachments_uploaded_successfully": "Allegati caricati con successo",
        "Attachment_removed_successfully": "Allegato rimosso con successo",
        "Attachment_not_removed": "Allegato non rimosso",
        "Please_try_again": "Per favore riprova",
        "Task_name_copied": "Nome del task copiato",
        "Status_already_exists": "Lo stato esiste già",
        "Status_added_sucessfully": "Stato aggiunto con successo",
        "Task_Type_already_exists": "Tipo di task già esistente",
        "Task_Type_added_sucessfully": "Tipo di task aggiunto con successo",
        "Image_size_must_be_less_than_ImageDimensions_pixels": "La dimensione dell'immagine deve essere inferiore a ImageDimensions pixel.",
        "Data_deleted_successfully": "Dati eliminati con successo.",
        "Category_created_successfully": "Categoria creata con successo",
        "Please_select_an_image_file": "Seleziona un file immagine",
        "Channel_created_successfully": "Canale creato con successo",
        "Folder_not_found": "Cartella non trovata",
        "Template_&_Project_data_has_been_added_successfully": "I dati del template e del progetto sono stati aggiunti con successo.",
        "Project_data_has_been_added_successfully": "I dati del progetto sono stati aggiunti con successo{filterMessage}",
        "Error_in_creating_project": "Errore nella creazione del progetto",
        "Milestone_deleted_successfully": "Traguardo eliminato con successo",
        "Error_in_deleting_milestone": "Errore nell'eliminazione del traguardo",
        "Milestone_added_successfully": "Traguardo aggiunto con successo",
        "Error_in_adding_milestone": "Errore nell'aggiungere il traguardo",
        "Milestone_update_successfully": "Traguardo aggiornato con successo",
        "Error_in_updating_milestone": "Errore nell'aggiornamento del traguardo",
        "Milestone_status_update_successfully": "Stato del traguardo aggiornato con successo",
        "Error_in_updating_milestone_status": "Errore nell'aggiornamento dello stato del traguardo",
        "Milestone_refund_amount_update_successfully": "Importo del rimborso del traguardo aggiornato con successo",
        "Error_in_updating_milestone_refund_amount": "Errore nell'aggiornamento dell'importo del rimborso del traguardo",
        "The_project_not_found": "Il progetto non è stato trovato.",
        "The_project_is_archived": "Il progetto è archiviato.",
        "Start_date_of_project_should_be_smaller_than_current_date": "La data di inizio del progetto deve essere inferiore alla data corrente",
        "All_the_range_is_included_in_milestone": "Tutto l'intervallo è incluso nel traguardo",
        "Please_enter_start_date_of_project": "Per favore inserisci la data di inizio del progetto",
        "Project_name_updated_successfully": "Nome del progetto aggiornato con successo",
        "Project restored successfully": "Progetto ripristinato con successo",
        "Project closed successfully": "Progetto chiuso con successo",
        "Project archived successfully": "Progetto archiviato con successo",
        "Project deleted successfully": "Progetto eliminato con successo",
        "Enter_valid_project_source": "Inserisci una fonte di progetto valida",
        "Please_select_sub_task": "Seleziona un sotto-task.",
        "Status_not_updated": "Stato non aggiornato",
        "Start_date_updated_successfully": "Data di inizio aggiornata con successo",
        "Start_date_not_updated": "Data di inizio non aggiornata",
        "Task_converted_sucessfully": "Task convertito con successo",
        "Task_merged_sucessfully": "Task unito con successo",
        "Can_not_create_template_name_Custom": "Non è possibile creare un template con il nome Custom",
        "Template_name_updated_successfully": "Nome del template aggiornato con successo.",
        "Template_has_been_created_Successfully": "Template creato con successo.",
        "Template_deleted_successfull": "Template eliminato con successo.",
        "Template_has_been_deleted_successfully": "Template eliminato con successo.",
        "Storage_exceeded_Upgrade_your_plan": "Memoria superata. Aggiorna il tuo piano",
        "max_filesize_messages": "La dimensione massima del file è FILE_SIZE MB.",
        "Password_reset_email_has_been_sent_successfully": "Email per il reset della password inviata con successo",
        "Invalid_username_or_password": "Nome utente o password non validi.",
        "Email_Not_Verified": "Email non verificata.",
        "Verification_mail_has_been_send_successfully": "Email di verifica inviata con successo",
        "Invalid_url": "URL non valido",
        "User_already_registered": "Utente già registrato.",
        "User_has_been_registered_successfully": "Utente registrato con successo.",
        "The_email_address_is_already_in_use": "L'indirizzo email è già in uso.",
        "User_has_been_registered_successfully_Please_verify_your_email_to_continue": "Utente registrato con successo, verifica la tua email per continuare.",
        "Password_reset_has_been_successfully": "Reset della password riuscito.",
        "Your_email_has_been_verify_successfully": "La tua email è stata verificata con successo.",
        "Invitation_accepted_successfully": "Invito accettato con successo.",
        "Only_product_owner_can_create_a_company": "Solo il proprietario del prodotto può creare una compagnia.",
        "Company_name_must_be_unique": "Il nome della compagnia deve essere unico.",
        "Subscription_cancel_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "Abbonamento annullato con successo. Attendere 2-3 minuti affinché le modifiche abbiano effetto ovunque.",
        "Subscription_reactivate_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "Abbonamento riattivato con successo. Attendere 2-3 minuti affinché le modifiche abbiano effetto ovunque.",
        "View_name_is_required": "Il nome della vista è obbligatorio.",
        "name_should_be_at_least_3_characters_long": "Il nome deve essere lungo almeno 3 caratteri.",
        "View_name_already_exists": "Il nome della vista esiste già.",
        "View_added_successfully": "Vista aggiunta con successo.",
        "View_Deleted_Successfully": "Vista eliminata con successo.",
        "Link_copied_to_clipboard_successfully": "Link copiato negli appunti con successo.",
        "Project_avatar_updated_successfully": "Avatar del progetto aggiornato con successo.",
        "Message pinned successfully": "Messaggio fissato con successo.",
        "Message unpinned successfully": "Messaggio rimosso dalla fissazione con successo.",
        "Message_copied": "Messaggio copiato.",
        "Item_cannot_be_empty": "L'elemento non può essere vuoto.",
        "Maximum_MAX_CHAR_characters_are_allowed": "Sono consentiti al massimo MAX_CHAR caratteri.",
        "Item_added_to_checklist": "Elemento aggiunto alla checklist.",
        "Maximum_10_files_can_be_uploaded_at_once": "Possono essere caricati al massimo 10 file contemporaneamente.",
        "file_type_is_not_supported": "Tipo di file non supportato!",
        "ERROR_in_file_upload": "ERRORE nel caricamento del file.",
        "file_size_is_larger_than_FILE_SIZE_mb": "La dimensione del file è maggiore di FILE_SIZE MB!",
        "Mark_as_favorite_successfully": "Contrassegnato come preferito con successo.",
        "Start_and_Due_date_updated_successfully": "Data di inizio e scadenza aggiornate con successo.",
        "Start_and_Due_date_not_updated": "Data di inizio e scadenza non aggiornata.",
        "Attchments_deleted_successfully": "Allegati eliminati con successo.",
        "Designation_is_required": "La designazione è obbligatoria.",
        "Designation_already_exists": "La designazione esiste già.",
        "Designation_added_successfully": "Designazione aggiunta con successo.",
        "Designation_updated_successfully": "Designazione aggiornata con successo.",
        "Role_is_required": "Il ruolo è obbligatorio.",
        "Role_already_exists": "Il ruolo esiste già.",
        "Role_added_successfully": "Ruolo aggiunto con successo.",
        "Role_updated_successfully": "Ruolo aggiornato con successo.",
        "Please_provide_an_email_id": "Si prega di fornire un'ID email.",
        "Please_provide_a_designation": "Si prega di fornire una designazione.",
        "Please_provide_a_role": "Si prega di fornire un ruolo.",
        "Designation_deleted_successfully": "Designazione eliminata con successo.",
        "The_role_is_already_in_use_so_it_can't_be_deleted": "Il ruolo è già in uso, quindi non può essere eliminato.",
        "Role_deleted_successfully": "Ruolo eliminato con successo.",
        "Language_not_updated": "Lingua non aggiornata!",
        "Profile_updated_successfully": "Profilo aggiornato con successo.",
        "Notification_Settings_Update_successfully": "Impostazioni di notifica aggiornate con successo.",
        "Permission_updated_successfully": "Permessi aggiornati con successo.",
        "Per_User_Generate_Limit_value_is_not_valid": "Il valore del limite di generazione per utente non è valido.",
        "Team_name_is_required": "Il nome del team è obbligatorio.",
        "Minimum_3_character_required": "Sono richiesti almeno 3 caratteri.",
        "Team_name_already_exist": "Il nome del team esiste già.",
        "Template_has_been_added_successfully": "Il template è stato aggiunto con successo.",
        "Billing_details_has_been_updated_successfully": "I dettagli di fatturazione sono stati aggiornati con successo.",
        "Billing_details_not_updated": "I dettagli di fatturazione non sono stati aggiornati.",
        "Invalid_Card_Details_Please_check_and_try_again": "Dettagli della carta non validi. Verifica e riprova.",
        "Expired_Card_Please_check_and_try_again": "Carta scaduta. Verifica e riprova.",
        "Invalid_card_verification_code_(CVC)_Please_check_and_try_again": "Codice di verifica della carta (CVC) non valido. Verifica e riprova.",
        "You_have_cancel_your_current_subscription_at_term_end_please_reactivate_subscription_and_try_again": "Hai annullato il tuo abbonamento alla fine del periodo. Riattiva l'abbonamento e riprova.",
        "Plan_not_purchased_Please_try_again": "Piano non acquistato. Riprova.",
        "Please_fill_out_billing_details_first": "Compila prima i dettagli di fatturazione.",
        "Please_check_your_credential": "Verifica le tue credenziali.",
        "File_type_not_supported": "Tipo di file non supportato.",
        "Are_you_sure_to_delete_this_file": "Sei sicuro di voler eliminare questo file?",
        "Select_Project_Type": "Seleziona il tipo di progetto.",
        "Tracker_user_added_successfully": "Utente Tracker aggiunto con successo.",
        "Tracker_user_removed_successfully": "Utente Tracker rimosso con successo.",
        "queue_list_not_updated": "Lista della coda non aggiornata.",
        "upgrade_plan_folder_limit_reached": "Aggiorna il piano. Hai raggiunto il limite per la creazione di cartelle.",
        "View_updated_successfully": "Vista aggiornata con successo.",
        "The_designation_is_already_in_use_so_it_cant_be_deleted": "La designazione è già in uso, quindi non può essere eliminata.",
        "Sprint_already_exists": "Sprint già esistente.",
        "Folder_already_exists": "Cartella già esistente.",
        "Sprint updated successfully": "Sprint aggiornato con successo.",
        "Project_milestone_status_updated_successfully": "Stato del traguardo del progetto aggiornato con successo.",
        "Invalid_email": "La tua email non è valida. Per favore controlla e riprova",
        "Invalid_password": "La tua password non è valida. Per favore controlla e riprova",
        "Too_many_request": "Troppe richieste. Per favore riprova più tardi",
        "Password_reset_link": "E-mail di scadenza della password inviata con successo! Controlla la tua casella di posta per procedere con il reset della password.",
        "Project_milestone_status_added_successfully": "Stato della tappa fondamentale del progetto aggiunto correttamente.",
        "Please_select_start_end_date": "Si prega di selezionare sia la data di inizio che quella di fine",
        "Invitation_canceled": "Invito annullato: Non puoi più utilizzare questo link",
        "Ai_limit_reached": "Il tuo limite giornaliero è stato raggiunto.",
        "You_have_reached_the_maximum_limit_of_guest_users": "Aggiorna il tuo piano. Hai raggiunto il limite massimo di utenti ospiti.",
        "Upgrade_for_import": "Aggiorna il tuo piano per accedere alla funzionalità di importazione.",
        "Upgrade_for_export": "Aggiorna il tuo piano per accedere alla funzionalità di esportazione.",
        "import_task_success": "Le tue attività sono state importate con successo.",
        "export_task_success": "Attività esportate con successo.",
        "export_task_error": "Non ci sono attività da esportare.",
        "invalid_file_error": "Tipo di file non valido. Si prega di caricare un file .csv.",
        "free_company_limit_reached": "Hai raggiunto il limite massimo per la creazione di aziende gratuite.",
        "Import_users_successfully": "Utenti importati con successo.",
        "date_range": "Seleziona un intervallo di date prima di applicare.",
        "Task_total_estimate_update_succesfull": "Aggiornamento totale della stima del task riuscito"
    },
    "SecurityAndPermission": {
        "project": "Progetto",
        "project_list": "Elenco progetti",
        "project_create": "Crea progetto",
        "project_name_edit": "Modifica nome progetto",
        "project_sprint_create": "Crea sprint progetto",
        "project_folder_create": "Crea cartella progetto",
        "project_folder_name_edit": "Modifica nome cartella progetto",
        "project_sprint_name_edit": "Modifica nome sprint progetto",
        "project_details": "Dettagli progetto",
        "project_status_change": "Cambia stato progetto",
        "project_assignee": "Assegnatario progetto",
        "project_category": "Categoria progetto",
        "project_source": "Fonte progetto",
        "project_type": "Tipo progetto",
        "project_currency": "Valuta progetto",
        "project_amount": "Importo progetto",
        "project_start_date": "Data inizio progetto",
        "project_end_date": "Data fine progetto",
        "project_due_date": "Data scadenza progetto",
        "project_close": "Chiudi progetto",
        "project_description": "Descrizione progetto",
        "project_checklist": "Checklist progetto",
        "project_checklist_assign_remove": "Assegna/rimuovi checklist progetto",
        "project_attachments": "Allegati progetto",
        "project_milestone": "Punto di riferimento progetto",
        "task": "Compito",
        "task_list": "Elenco compiti",
        "task_create": "Crea compito",
        "sub_task_create": "Crea sotto-compito",
        "task_name_edit": "Modifica nome compito",
        "task_status": "Stato compito",
        "task_assignee": "Assegnatario compito",
        "task_priority": "Priorità compito",
        "task_due_date": "Data scadenza compito",
        "task_estimated_hours": "Ore stimate compito",
        "task_description": "Descrizione compito",
        "task_checklist": "Checklist compito",
        "task_checklist_assign_remove": "Assegna/rimuovi checklist compito",
        "task_attachments": "Allegati compito",
        "show_tasks": "Mostra compiti",
        "task_custom_field": "Campo personalizzato",
        "settings": "Impostazioni azienda",
        "settings_edit_company": "Modifica azienda",
        "settings_task_priority": "Priorità compito",
        "settings_file_extensions": "Estensioni file",
        "settings_project_milestone_status": "Stato punto di riferimento progetto",
        "settings_invite_member": "Invita membro",
        "settings_member_list": "Elenco membri",
        "settings_create_team": "Crea team",
        "settings_team_list": "Elenco team",
        "settings_project_list": "Elenco progetti",
        "settings_security_permissions": "Sicurezza e permessi",
        "settings_role_management": "Gestione ruoli",
        "settings_designation": "Designazione",
        "milestone_weekly_range": "Intervallo settimanale punto di riferimento",
        "settings_custom_field": "Campo personalizzato",
        "sheet_settings": "Impostazioni foglio",
        "user_timesheet": "Foglio presenze utente",
        "project_timesheet": "Foglio presenze progetto",
        "workload_timesheet": "Foglio presenze carico di lavoro",
        "milestone_report": "Rapporto punto di riferimento",
        "artificial_intelligence": "Intelligenza Artificiale",
        "per_user_generate_limit": "Limite token per utente",
        "project_custom_field": "Campo personalizzato progetto",
        "public_projects": "Elenco progetti pubblici",
        "tracker_timesheet": "Foglio presenze tracker",
        "view_list": "Visualizza elenco",
        "chat": "Chiacchierata",
        "project_delete": "Eliminazione del progetto",
        "folder_archive": "Archiviazione della cartella",
        "folder_delete": "Eliminazione della cartella",
        "folder_restore": "Ripristino della cartella",
        "sprint_type_change": "Modifica del tipo di sprint",
        "sprint_restore": "Ripristino dello sprint",
        "sprint_delete": "Eliminazione dello sprint",
        "sprint_archive": "Archiviazione dello sprint",
        "chat_channel": "Crea canale chat",
        "chat_category": "Crea categoria chat",
        "one_to_one_chat": "Chat uno a uno",
        "task_tag": "Tag attività",
        "task_start_date": "Data di inizio attività",
        "task_activity_log": "Registro attività",
        "task_convert_to_list": "Converti attività in lista",
        "task_convert_to_subtask": "Converti attività in sottoattività",
        "task_duplicate": "Duplica attività",
        "task_merge": "Unisci attività",
        "task_move": "Sposta attività",
        "task_archive": "Archivia attività",
        "task_delete": "Elimina attività",
        "task_comment": "Commento attività",
        "task_details": "Dettaglio attività",
        "queue_list": "Lista di attesa",
        "advance_search": "Ricerca avanzata",
        "list_view_column": "Colonna vista elenco",
        "task_type": "Tipo di attività",
        "import_tasks": "Importa attività",
        "export_tasks": "Esporta attività",
        "convert_to_task": "Converti in attività"
    },
    "general": {
        "Continue": "Continua",
        "New_Status": "Nuovo stato",
        "Old_Status": "Vecchio stato",
        "Old_Task_Type": "Vecchio tipo di compito",
        "New_Task_Type": "Nuovo tipo di compito",
        "New_Task_Assignee": "Nuovo assegnatario compito",
        "Old_Task_Assignee": "Vecchio assegnatario compito",
        "New_Task_Watchers": "Nuovi osservatori compito",
        "Old_Task_Watchers": "Vecchi osservatori compito",
        "Select_Status": "Seleziona stato",
        "Select_Task_Type": "Seleziona tipo di compito",
        "No_Assignee": "Nessun assegnatario",
        "No_Watchers": "Nessun osservatore",
        "Different_Statuses": "Stati diversi",
        "Please_Select_Status": "Seleziona stato",
        "Tomorrow": "Domani",
        "Yesterday": "Ieri",
        "Project": "Progetto",
        "Team": "Team",
        "User": "Utente",
        "Copy_Assignees": "Copia assegnatari",
        "Copy_Watchers": "Copia osservatori",
        "apply": "Applica",
        "current_month": "Mese corrente",
        "current_week": "Settimana corrente",
        "keyboard": "Tastiera",
        "mouse": "Mouse",
        "Create": "Crea",
        "scroll_to_bottom": "Scorri fino in fondo",
        "unassigned": "Non assegnato",
        "entries": "voci",
        "showing": "Mostrando",
        "page_not_found": "Ops, pagina non trovata",
        "page_not_found_description": "Ci scusiamo per il disagio. Sembra che tu stia cercando di accedere a una pagina che è stata eliminata o non è mai esistita.",
        "note": "Nota",
        "settings_change_no_effect": "Il cambiamento delle impostazioni sotto non avrà effetto sui valori dei campi correnti se non vuoti",
        "advanced": "Avanzato",
        "general": "Generale",
        "limits": "Limiti",
        "message_deleted": "Messaggio eliminato",
        "company_individual": "Nome dell'azienda/individuo",
        "enter_company_individual": "Inserisci il nome dell'azienda/individuo"
    },
    "monthName": {
        "jan": "Gen",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Apr",
        "may": "Mag",
        "jun": "Giu",
        "jul": "Lug",
        "aug": "Ago",
        "sep": "Set",
        "oct": "Ott",
        "nov": "Nov",
        "dec": "Dic"
    },
    "timeLog": {
        "start_time_field_required": "Il campo dell'orario di inizio è obbligatorio",
        "end_time_field_required": "Il campo dell'orario di fine è obbligatorio",
        "select_valid_time_duration": "Seleziona una durata valida del tempo"
    },
    "weekName": {
        "sun": "Dom",
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mer",
        "thu": "Gio",
        "fri": "Ven",
        "sat": "Sab",
        "fridays": "Venerdì",
        "mondays": "Lunedì",
        "saturdays": "Sabato",
        "sundays": "Domenica",
        "thursdays": "Giovedì",
        "tuesdays": "Martedì",
        "wednesdays": "Mercoledì"
    },
    "tooltipText": {
        "enable_app_manage_priority": "Abilitando questa app sarai in grado di gestire <b>Priorità</b> nei <b>Compiti</b> per questo <b>progetto</b>",
        "enable_app_manage_multiple_assignee": "Abilitando questa app sarai in grado di gestire <b>Assegnatari multipli</b> nei <b>Compiti</b> per questo <b>progetto</b>",
        "enable_app_manage_time_estimates": "Abilitando questa app sarai in grado di gestire <b>Stime del tempo</b> nei <b>Compiti</b> per questo <b>progetto</b>",
        "enable_app_manage_tags": "Abilitando questa app sarai in grado di gestire <b>Tag</b> nei <b>Compiti</b> per questo <b>progetto</b>",
        "enable_app_use_milestones": "Abilitando questa app sarai in grado di utilizzare <b>Punti di riferimento</b> per questo <b>progetto</b>",
        "enable_app_use_ai_operations": "Abilitando questa app sarai in grado di utilizzare <b>Operazioni AI</b> per questo <b>progetto</b>",
        "enable_app_manage_time_log": "Abilitando questa app sarai in grado di gestire <b>Registro del tempo</b> nei <b>Compiti</b> per questo <b>progetto</b>",
        "enable_app_manage_custom_fields": "Abilitando questa app sarai in grado di gestire <b>Campi personalizzati</b> per questo <b>progetto</b>"
    },
    "Company": {
        "fill_company_details": "Compila i dettagli della tua azienda",
        "set_up_company": "Configura la tua azienda",
        "creating_company": "Creazione azienda in corso",
        "company_created": "La tua azienda è stata creata. Abbiamo configurato i passaggi iniziali. Attendere un momento.",
        "good_to_go": "Tutto pronto",
        "select_default_country": "Seleziona il paese predefinito",
        "freelimitreachedstart": "Hai già creato un'azienda gratuita. Per creare una nuova azienda, devi prima passare a un piano a pagamento",
        "freelimitreachedend": "Una volta effettuato l'upgrade, sarai pronto per aggiungere un'altra azienda gratuita."
    },
    "Subscription": {
        "subscription_cancelled": "Hai annullato il tuo abbonamento alla fine del periodo di abbonamento attuale",
        "discard_changes": "Un utente del tuo abbonamento annullerà queste modifiche e il tuo abbonamento attuale continuerà dal prossimo ciclo di fatturazione.",
        "confirm_terminate_schedule": "Sei sicuro di voler terminare la cancellazione pianificata dell'abbonamento?",
        "confirm_add_user": "Sei sicuro di voler aggiungere un utente al tuo abbonamento?",
        "confirm_remove_user": "Sei sicuro di voler rimuovere l'utente dall'abbonamento?",
        "next_invoice_amount": "La tua prossima fattura sarà di",
        "credits_applied": "Crediti applicati",
        "current_billing_for_upgrade": "Fatturazione attuale per l'upgrade",
        "plan_upgrade_success": "Congratulazioni! L'upgrade del tuo piano è stato programmato con successo e le migliorie entreranno in vigore al termine dell'attuale periodo. Preparati a sperimentare le funzionalità e i benefici migliorati nella prossima fase del tuo abbonamento.",
        "subscription_upgrade_from": "Il tuo abbonamento sarà aggiornato da",
        "total_payable_amount": "Importo totale da pagare",
        "update_subscription": "Aggiorna abbonamento",
        "updated_subscription_price": "Prezzo aggiornato dell'abbonamento",
        "upgrade_subscription": "Aggiorna abbonamento",
        "confirm_subscription_change": "Sei sicuro di voler cambiare il tuo abbonamento da",
        "monthly": "Mese",
        "yearly": "Anno",
        "remove_scheduled_cancellation_confirmation": "Cliccando su 'Sì' rimuoverai la cancellazione pianificata e il tuo ciclo di fatturazione continuerà.",
        "scheduled_cancellation_notice": "Hai una cancellazione pianificata del tuo abbonamento attuale il",
        "credit_entitlement_congratulations": "Congratulazioni! Hai diritto a un credito di",
        "credit_note_application": "per il tuo abbonamento attuale. Questa nota di credito verrà applicata facilmente per migliorare il tuo abbonamento e verrà automaticamente dedotta dalle tue prossime fatture, garantendo valore e risparmi continui per il tuo percorso di abbonamento.",
        "invoice_period_coverage": "La fattura copre il periodo dal"
    },
    "Card": {
        "pay_with": "Paga con",
        "add_new_card": "Aggiungi nuova carta",
        "name_on_card": "Nome sulla carta",
        "card_number": "Numero carta",
        "expiry": "Scadenza",
        "cvc": "CVC"
    },
    "alertBox": {
        "updateBillingAddress": "Devi aggiornare il primo indirizzo di fatturazione",
        "valid_csv_title": "File non caricato",
        "valid_csv_text": "Carica un file .csv valido per procedere.",
        "ok": "OK",
        "cancel": "Annulla",
        "go_back_title": "Tornare indietro?",
        "go_back_text": "Sei sicuro di voler tornare al passaggio precedente?",
        "close_modal_title": "Chiudere la finestra?",
        "close_modal_text": "Sei sicuro di voler chiudere la finestra? Tutte le informazioni inserite in questo passaggio andranno perse.",
        "no": "No",
        "yes": "Sì",
        "confirm": "Conferma",
        "improper_header_selection_title": "Selezione non valida",
        "improper_header_selection_text": "La riga selezionata contiene valori non testuali. Seleziona un'altra riga.",
        "missing_fields_title": "Campi obbligatori mancanti",
        "missing_fields_text": "Devi assegnare e confermare tutti i campi obbligatori prima di procedere.",
        "warning_title": "Attenzione",
        "warning_text": "Se procedi, i valori vuoti in 'Priorità del compito' e 'Stato' verranno automaticamente impostati su 'Media' e 'In sospeso'.",
        "incomplete_mapping_title": "Mappatura incompleta",
        "incomplete_mapping_text": "Si prega di mappare almeno tutti i valori univoci a un valore in Hyphen OI Pro prima di procedere.",
        "invalid_tasks_error": "Nessuna attività valida trovata. Assicurati che i campi obbligatori non siano vuoti."
    },
    "importTaskButton": {
        "import_title": "Importa attività",
        "import_button": "Importa compiti da CSV",
        "back_button": "Indietro",
        "next_button": "Avanti",
        "export_button": "Esporta come CSV",
        "import_processing": "Le tue attività sono in fase di importazione."
    },
    "importCsvAndSetHeader": {
        "download": "Scarica",
        "demo_csv": "CSV di esempio",
        "down_demo_text": "Confronta questo file con quello che vuoi importare per assicurarti che il formato sia corretto.",
        "upload_button": "Carica qui il tuo file CSV",
        "upload_instructions": "Puoi caricare qualsiasi file .csv con qualsiasi set di colonne, dove ogni riga rappresenta un record. Nel passaggio successivo potrai mappare le colonne ai dati corrispondenti. Prima dell'importazione finale, potrai eliminare o correggere eventuali dati errati.",
        "header_row_question": "La riga selezionata contiene le intestazioni delle colonne?",
        "select_another_button": "Seleziona un'altra riga",
        "confirm_row_btt": "Conferma"
    },
    "headerMapping": {
        "title": "Mappa le intestazioni delle colonne",
        "mapping_instructions": "Abbina le intestazioni delle tue colonne ai campi di Hyphen OI Pro",
        "pending_count": "Campi rimanenti:",
        "confirmed_count": "Campi confermati:",
        "ignored_count": "Campi ignorati:",
        "custom_count": "Campi personalizzati:",
        "confirmed_text": "Confermato",
        "ignored_text": "Ignorato",
        "edit_button": "Modifica",
        "no_match_title": "Nessuna corrispondenza",
        "no_match": "Nessuna corrispondenza trovata",
        "no_match_description": "Questo campo non corrisponde a nessuna intestazione di Hyphen OI Pro. Puoi ignorarlo o aggiungerlo come campo personalizzato.",
        "custom_field_button": "Aggiungi come campo personalizzato",
        "ignore_field_button": "Ignora questo campo",
        "matched_to_field": "Mappato al campo:",
        "duplication_warning": "Questo campo è duplicato e non può essere confermato. Seleziona un altro campo.",
        "confirm_map_button": "Conferma mappatura"
    },
    "reviewMaping": {
        "title": "Rivedi i dati mappati ai campi. (Puoi anche modificare i valori qui.)",
        "warning": "Uno o più campi obbligatori sono mancanti o contengono valori non validi. Controllali, altrimenti queste righe non verranno importate."
    },
    "valueMapping": {
        "user_mapping_title": "Mappatura utenti",
        "user_mapping_instruction": "Abbina gli utenti al loro corrispettivo in Hyphen OI Pro per garantire una corretta assegnazione di responsabili, leader e attività. Se non viene effettuata la mappatura, questi dati non verranno importati.",
        "user_dropdown_text": "Seleziona utente",
        "status_mapping_title": "Mappatura stato",
        "status_mapping_instruction": "Per garantire un flusso di lavoro coerente, abbina i tuoi valori di stato a quelli esistenti in Hyphen OI Pro. Questo aiuterà a prevenire errori futuri.",
        "status_dropdown_text": "Seleziona stato",
        "priority_mapping_title": "Mappatura priorità",
        "priority_mapping_instruction": "Per garantire un flusso di lavoro coerente, abbina i tuoi valori di priorità a quelli esistenti in Hyphen OI Pro. Questo aiuterà a prevenire errori futuri.",
        "priority_dropdown_text": "Seleziona priorità",
        "custom_field_mapping_title": "Mappatura campi personalizzati",
        "custom_field_mapping_instruction": "Per garantire la compatibilità, abbina il tipo di campo personalizzato a un tipo di campo esistente in Hyphen OI Pro. Questo aiuterà a prevenire errori futuri.",
        "custom_delimiters_quest": "ℹ️ I tuoi campi personalizzati contengono delimitatori?"
    },
    "importMappingKeywords": {
        "task_id_description": "L'ID del compito specifico.",
        "task_name_description": "Il nome del compito, solitamente un breve riassunto.",
        "task_description_description": "Informazioni dettagliate sul compito.",
        "task_assignee_description": "L'indirizzo e-mail della persona assegnata al compito.",
        "task_parentId_description": "L'ID del compito principale a cui è associato questo compito.",
        "task_leaderId_description": "L'ID utente della persona che guida questo compito.",
        "task_priority_description": "Il livello di importanza assegnato al compito.",
        "task_status_description": "Lo stato attuale o il progresso del compito.",
        "task_start_date_description": "La data di inizio del compito.",
        "task_due_date_description": "La data entro cui il compito deve essere completato."
    },
    "Affiliate": {
        "refer_earn": "Invita e guadagna",
        "unlimited": "Illimitato",
        "invite_start_earning_cash_rewards": "Invita i tuoi amici e inizia a guadagnare premi in denaro.",
        "your_referral_code": "Il tuo codice di riferimento",
        "invite_spend_message": "Per ogni spesa del tuo amico, riceverai il {percentage}% dell'importo come ricompensa.",
        "inviteText": "Invita gli amici condividendo questo link",
        "copy": "Copia",
        "refferal_code_label": "Codice di riferimento",
        "refferal_code_placeholder": "Inserisci il codice di riferimento",
        "invalid_refferal_model_title": "Il tuo codice di riferimento non è valido",
        "invalid_refferal_model_confirm_text": "Sì, crealo!",
        "invalid_refferal_model_text": "Sei sicuro di voler creare un'azienda?",
        "refferal_code_error": "Il codice di riferimento non è valido"
    },
    "dashboardCard": {
        "tasks_by_assignee_bar_chart_description": "Visualizza un grafico a barre delle tue attività totali per assegnatario",
        "tasks_by_assignee_bar_chart_title": "Attività per Assegnatario",
        "task_list_description": "Crea una vista elenco utilizzando le attività di qualsiasi posizione",
        "tasks_list_title": "Elenco Attività",
        "tasks_by_assignee_stack_bar_chart_description": "Visualizza un grafico a barre impilate delle tue attività totali per assegnatario",
        "tasks_by_assignee_stack_bar_chart_title": "Attività per Assegnatario",
        "workload_by_status_stack_bar_chart_description": "Visualizza una ripartizione dei tuoi stati in diverse posizioni",
        "workload_by_status_stack_bar_chart_title": "Carico di Lavoro per Stato",
        "tasks_by_assignee_pie_chart_description": "Visualizza un grafico a torta delle tue attività totali per assegnatario",
        "tasks_by_assignee_pie_chart_title": "Attività per Assegnatario",
        "workload_by_status_pie_chart_description": "Visualizza un grafico a torta dell'uso dei tuoi stati nelle varie posizioni",
        "workload_by_status_pie_chart_title": "Carico di Lavoro per Stato",
        "workload_by_status_bar_chart_description": "Visualizza un grafico a barre dell'uso dei tuoi stati nelle varie posizioni",
        "workload_by_status_bar_chart_title": "Carico di Lavoro per Stato",
        "queue_list_title": "Elenco di Attesa",
        "queue_list_description": "Visualizza un elenco delle tue attività insieme ai loro stati.",
        "card_name": "Nome della Carta",
        "location": "progetto",
        "group_by": "Raggruppa per",
        "show_assignees": "Mostra assegnatari",
        "include_subtasks": "Includi sottocompiti",
        "display_labels_as_percent": "Visualizza etichette come percentuale",
        "show_legend": "Mostra legenda",
        "show_Data_Labels": "Mostra etichette dati",
        "select": "Seleziona",
        "add_card": "Aggiungi Carta",
        "back": "Indietro",
        "error_assignees": "Il campo 'Mostra assegnatari' è obbligatorio",
        "error_location": "Il campo 'Posizione' è obbligatorio",
        "empty_layout_container": "La tua dashboard è vuota. Fai clic su 'Aggiungi scheda' per iniziare.",
        "status": "stato",
        "edit_card": "modifica carta",
        "calendar_card_title": "Calendario",
        "calendar_card_description": "Questa è la vista calendario per le attività",
        "measure": "misura",
        "calculation": "calcolo",
        "total_urgent_tasks": "Totale attività urgenti",
        "total_urgent_tasks_description": "Mostra il numero totale di attività urgenti per posizione",
        "time_tracker": "Tracciatore di tempo",
        "time_estimate": "Stima del tempo",
        "range": "Intervallo",
        "max": "Massimo",
        "min": "Minimo",
        "median": "Mediana",
        "average": "Media",
        "sum": "Somma",
        "workload_estination_title": "Rendicontazione del tempo",
        "workload_estination_description": "Vedi attività con tempo tracciato e stimato.",
        "workload_only_estination_title": "Tempo stimato",
        "workload_only_estination_description": "Vedi il tempo stimato.",
        "time_only_estination_title": "Tempo registrato",
        "time_only_estination_description": "Vedi il tempo registrato.",
        "today": "Oggi",
        "yesterday": "Ieri",
        "this_week": "Questa settimana",
        "last_week": "La settimana scorsa",
        "this_month": "Questo mese",
        "last_month": "Il mese scorso",
        "this_year": "Quest'anno",
        "last_30_days": "Ultimi 30 giorni",
        "task": "Conteggio attività",
        "task_label": "Etichetta attività",
        "both": "Mostra entrambi",
        "manual_time": "Mostra solo il tempo manuale",
        "track_time": "Mostra solo il tempo tracciato",
        "logtype": "Registri del tempo",
        "timerange": "Periodo di tempo",
        "priority": "Priorità",
        "due_date": "Data di scadenza",
        "none": "Nessuno",
        "total_time_track_description": "Mostra il tempo totale tracciato",
        "total_time_track_tasks": "Tempo totale tracciato",
        "total_tasks_count_description": "Mostra il numero totale di attività",
        "total_tasks_count": "Numero totale di attività",
        "assignees": "Assegnatari",
        "feature": "Funzionalità",
        "workload": "Carico di lavoro",
        "time_tracking": "Tracciamento del tempo",
        "task_card": "Attività",
        "Today": "Oggi",
        "Yesterday": "Ieri",
        "Tomorrow": "Domani",
        "This_week": "Questa settimana",
        "Next_week": "La prossima settimana",
        "Next_seven_days": "I prossimi sette giorni",
        "Last_seven_days": "Gli ultimi sette giorni",
        "Last_month": "Il mese scorso",
        "This_month": "Questo mese",
        "Next_month": "Il prossimo mese",
        "Date_range": "Intervallo di date",
        "me_mode": "io",
        "data": "Dati",
        "display": "Visualizza",
        "fields": "Campi"
    },
    "designationMapping": {
        "title": "Mappatura delle Designazioni",
        "description": "Si prega di mappare le designazioni nel proprio CSV con le designazioni esistenti in Hyphen OI Pro."
    },
    "roleMapping": {
        "title": "Mappatura dei Ruoli",
        "description": "Si prega di mappare i ruoli nel proprio CSV con i ruoli esistenti in Hyphen OI Pro."
    },
    "importUserKeywords": {
        "user_email_description": "ID e-mail dell'utente",
        "user_role_description": "Il ruolo o il titolo di lavoro assegnato all'utente all'interno dell'organizzazione.",
        "user_designation_description": "La designazione ufficiale o il titolo di lavoro del dipendente all'interno dell'azienda."
    },
    "userSelection": {
        "title": "Selezione Utente",
        "user_limit_error": "Limite massimo di utenti raggiunto. Si prega di aggiornare il piano per importare più utenti.",
        "description": "Seleziona tutti gli utenti che desideri importare.",
        "duplicate_email_error": "Questo ID e-mail esiste già in Hyphen OI Pro. Non è possibile importarlo.",
        "invalid_email": "Questo ID e-mail non è valido. Si prega di utilizzare un ID e-mail valido.",
        "invalid_fields": "Hai uno o più campi non validi. Si prega di controllare i campi evidenziati.",
        "user_limit_100": "Puoi importare un massimo di 100 utenti alla volta."
    },
    "importUserButton": {
        "import_user_processing": "I tuoi utenti stanno venendo importati"
    },
    "timeForecastingReport": {
        "project_name": "Nome del progetto",
        "project_status": "Stato del progetto",
        "start_date": "Data di inizio",
        "due_date": "Data di scadenza",
        "last_logged_date": "Ultima data registrata",
        "budget": "Budget",
        "actual": "Effettivo",
        "forecast": "Previsione",
        "estimated_hours": "Ore stimate",
        "logged_hours": "Ore registrate",
        "remaining_hours": "Ore rimanenti",
        "overdue_hours": "Ore scadute",
        "estimated_time_to_complete": "Tempo stimato per completare",
        "estimated_complition_date": "Data stimata di completamento",
        "show_legends": "Mostra legende",
        "show_data_labels": "Mostra etichette dei dati",
        "report_type": "Tipo di rapporto"
    }
}